import React, {useEffect, useRef, useState, useMemo} from 'react';
import axios from 'axios';
import {RouteComponentProps} from 'react-router-dom';
import {Button, Col, Row} from 'reactstrap';
import {Storage, translate, Translate, ValidatedField} from 'react-jhipster';
import {createTheme, responsiveFontSizes, ThemeProvider} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import {DialogProps} from '@mui/material/Dialog';
import {useAppDispatch, useAppSelector} from 'app/config/store';
import {getEntityWithoutPending, updateEntity, resendTransferSms, resendSoldSms} from '../quotation.reducer';
import {IUser} from 'app/shared/model/user.model';
import Grid from '@mui/material/Grid';
import {
  createEntity as createPurchaseCancellation,
  getEntityByQuotation as getPurchaseCancellationByQuoId,
  updateEntity as updatePurchaseCancellation
} from 'app/entities/purchase-cancellation/purchase-cancellation.reducer';

import {
  getAllAlshmokhAdminUsers,
  getAllAlshmokhStaffUsers,
  getBranchManagerUser,
  getUserByAlshmokhAdmin,
  getUserByIdAsOtherRoles,
  getUserByLogin,
  getUserRoleAccessByUserId,
  getUsersAsAlmoskhAdminAndStaff
} from 'app/modules/administration/user-management/user-management.reducer';
import '../quotation-update.css';
import './quotation-bought.scss';
import {AUTHORITIES, defaultUser} from 'app/config/constants';
import {
  createEntity as createNotification,
  sendEmailKeepRequestedCustomer,
  sendPoCancelEmail
} from "app/entities/notification-record/notification-record.reducer";
import {
  getAllEntities as getNotificationTemplates
} from 'app/entities/notification-template/notification-template.reducer';
import {
  getEntities as getBursaEmails
} from 'app/entities/notify-cancellation-emails/notify-cancellation-emails.reducer';
import {handleRegister} from 'app/modules/account/register/register.reducer';
import {getEntity as getBranch} from "app/entities/branch/branch.reducer";
import {
  createEntity as createBursaBidCert,
  updateEntity as updateBursaBidCert,
  getEntityByEcertNo as getBursaBidCertByEcertNo
} from "app/entities/bursa-api-bid-cert/bursa-api-bid-cert.reducer";
import {
  createEntity as createBursaOtcCert,
  updateEntity as updateBursaOtcCert,
  getEntityByEcertNo as getBursaOtcCertByEcertNo
} from "app/entities/bursa-api-otc-cert/bursa-api-otc-cert.reducer";
import {
  createEntity as createBursaStbCert,
  updateEntity as updateBursaStbCert,
  getEntityByEcertNo as getBursaStbCertByEcertNo
} from "app/entities/bursa-api-stb-cert/bursa-api-stb-cert.reducer";
import {getEntity as getComexSetting} from 'app/entities/comex-settings/comex-settings.reducer';
import moment from "moment/moment";
import 'moment-timezone';
import {countryList} from "app/entities/bank/country";
import ErrorDialog from 'app/shared/error/error-dialog';
import {createEntity, getEntityByQuotationId, updateEntity as updateIban} from "app/entities/quotation/iban-reducer";
import {IIban} from "app/shared/model/iban.model";
import {ICommodity} from "app/shared/model/commodity.model";
import {
  isDuringFridayPrayer,
  isFriday
} from 'app/shared/util/date-utils';
import {resolveLumpSumFeeAmount, isCommissionModeForBank, resolveCurrencyIdForFiltering} from 'app/shared/util/quotation-utils';
import {getFeeListByBankIdAndCommodityType} from 'app/entities/comex-bank-fee/comex-bank-fee.reducer';
import SmsDialog from 'app/entities/quotation/bought/components/sms-dialog';
import RequestCancellationDialog
  from 'app/entities/quotation/bought/components/request-cancellation-dialog';
import ApprovalDialog from 'app/entities/quotation/bought/components/approval-dialog';
import QuotationBoughtForm from 'app/entities/quotation/bought/components/quotation-bought-form';
import {
  inputStyle,
  labelStyle,
  StyledTable,
  StyledTableCell
} from 'app/entities/quotation/bought/quotation-bought.style';
import {
  CertExistsConfirmationDialog
} from 'app/entities/quotation/bought/components/cert-exists-confirmation-dialog';
import {ManualOrderDialog} from 'app/entities/quotation/bought/components/manual-order-dialog';
import {IbanForm} from 'app/entities/quotation/bought/components/iban-form';
import {QuotationTitle} from 'app/entities/quotation/bought/components/quotation-title';
import {CancelOrderButton} from 'app/entities/quotation/bought/components/cancel-order-button';
import {TransactionForms} from 'app/entities/quotation/bought/components/transaction-forms';
import {AddIbanDialog} from 'app/entities/quotation/bought/components/add-iban-dialog';
import {AddBuyerDialog} from 'app/entities/quotation/bought/components/add-buyer-dialog';
import {IQuotation} from 'app/shared/model/quotation.model';
import {DocUploadForm} from 'app/entities/quotation/bought/components/doc-upload-form';
import {LocalFormSection} from "app/entities/quotation/components/local-form-section";
import {ResendSmsDialog} from "app/entities/quotation/bought/components/resend-sms-dialog";
import SlotProcessingDialog from "app/entities/quotation/bought/components/slot-processing-dialog";
import {AmountTransferredSection} from "app/entities/quotation/components/amount-transferred-section";
import {FormsTableSection} from "app/entities/quotation/bought/components/form-table-section";


export const QuotationBought = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();
  const specBranch = useAppSelector(state => state.branch.entity);
  const account = useAppSelector(state => state.authentication.account);
  const quotationEntity = useAppSelector<IQuotation>(state => state.quotation.entity);
  const purchaseCancellation = useAppSelector(state => state.purchaseCancellation.entity);
  const updating = useAppSelector(state => state.quotation.updating);
  const updateSuccess = useAppSelector(state => state.purchaseCancellation.updateSuccess);
  const quotationSuccess = useAppSelector(state => state.quotation.updateSuccess);
  const notificationTemplates = useAppSelector(state => state.notificationTemplate.entities);
  const notificationSuccess = useAppSelector(state => state.notificationRecord.updateSuccess);
  const userRoleAccessList = useAppSelector(state => state.userManagement.userRoleAccessList);
  const bankStaffAccount = useAppSelector(state => state.userManagement.bankStaff);
  const customerAccount = useAppSelector(state => state.userManagement.customer);
  const branchManagerAccounts = useAppSelector(state => state.userManagement.branchManagers);
  const alshmokhAdminUsers = useAppSelector(state => state.userManagement.allAlshmokhAdmin);
  const alshmokhStaffUsers = useAppSelector(state => state.userManagement.allAlshmokhStaff);
  const bursaEmails = useAppSelector(state => state.notifyCancellationEmails.entities);
  const comexSettingsEntity = useAppSelector(state => state.comexSettings.entity);
  const resendSmsLoading = useAppSelector(state => state.quotation.resendSmsLoading);
  const resendSmsSuccess = useAppSelector(state => state.quotation.resendSmsSuccess);
  const resendSmsError = useAppSelector(state => state.quotation.resendSmsError);
  const files = useAppSelector(state => state.file.entities);
  const bankFeeList = useAppSelector(state => state.comexBankFee.entities);

  const [requestCancellationReason, setRequestCancellationReason] = useState("");
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isKeepDialogOpen, setIsKeepDialogOpen] = useState(false);
  const [isTransferRequested, setIsTransferRequested] = useState(false);
  const [isSold, setIsSold] = useState(false);
  const [isProcessingTransfer, setIsProcessingTransfer] = useState(false);
  const [isProcessingPurchase, setIsProcessingPurchase] = useState(false);
  const [isProcessingSell, setIsProcessingSell] = useState(false);
  const [slotAlreadyProcessing, setSlotAlreadyProcessing] = useState<'transfer' | 'purchase' | 'sell' | null>(null);
  // Synchronous guards — React state updates are async so two fast clicks can both
  // pass the `if (isProcessing...) return` check before a re-render disables the button.
  const purchaseInProgressRef = useRef(false);
  const transferInProgressRef = useRef(false);
  const sellInProgressRef = useRef(false);
  const [isConfirmingTransfer, setIsConfirmingTransfer] = useState(false);
  const [isRepurchase, setIsRepurchase] = useState(false);
  const [approveByBranch, setApproveByBranch] = useState(false);
  const [cancel, setCancel] = useState(false);
  const [cancelDeny, setCancelDeny] = useState(false);
  const [requestCancel, setRequestCancel] = useState(false);
  const [keepCus, setKeepCus] = useState(false);
  const [manager, setManager] = useState([] as IUser);
  const [alshmokhAdmin, setAlshmokhAdmin] = useState([] as IUser);
  const [isEditUploadCert, setIsEditUploadCert] = useState(false);
  const [isSaveClick, setIsSaveClick] = useState(false);
  const [openCertExistDialog, setOpenCertExistDialog] = useState(false);
  const [isBidId, setIsBidId] = useState(false);
  const [isOtcId, setIsOtcId] = useState(false);
  const [isStbId, setIsStbId] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const [maxWidth, setMaxWidth] = useState<DialogProps['maxWidth']>('sm');
  const [poNumberData, setPoNumberData] = useState('');
  const [poCreatedDateData, setPoCreatedDateData] = useState('');
  const [amountData, setAmountData] = useState('');
  const [commodityNameData, setCommodityNameData] = useState('');
  const [descriptionData, setDescriptionData] = useState('');
  const [itemDescriptionInArabic, setItemDescriptionInArabic] = useState('');
  const [commodityUnitPriceData, setCommodityUnitPriceData] = useState('');
  const [commodityQuantityData, setCommodityQuantityData] = useState('');
  const [commodityUnitData, setCommodityUnitData] = useState('');
  const [transactionFeeData, setTransactionFeeData] = useState('');
  const [feeInQuotationCurrencyData, setFeeInQuotationCurrencyData] = useState('');
  const [totalAmountData, setTotalAmountData] = useState('');
  const [customerICData, setCustomerICData] = useState('');
  const [customerNameData, setCustomerNameData] = useState('');
  const [customerNameArData, setCustomerNameArData] = useState('');
  const [customerNationalityData, setCustomerNationalityData] = useState('');
  const [customerTelData, setCustomerTelData] = useState('');
  const [customerEmailData, setCustomerEmailData] = useState('');
  const [branchCustomerApproval, setBranchCustomerApproval] = useState<boolean>(null);
  const [checkedCustomerApproval, setCheckedCustomerApproval] = useState(false);
  const [errCustApprovalMsg, setErrCustApprovalRoleMsg] = useState("");
  const [openSMSModal, setOpenSMSModal] = React.useState(false);
  const [SMSLanguage, setSMSLanguage] = Storage.session.get('locale') === 'en' ? useState('EN') : useState('AR');
  const [validateCancellation, setValidateCancellation] = React.useState(false);
  const [errorText, setErrorText] = React.useState(false);
  const [loading, setLoading] = useState(true);
  const [operationTime, setOperationTime] = useState(true);
  const [openManualOrderDialog, setOpenManualOrderDialog] = useState(false);
  const [ecertBursaValue, setEcertBursaValue] = useState("");
  const fileUpload = useRef(null);
  const [bidFileName, setBidFileName] = useState(null);
  const [otcFileName, setOtcFileName] = useState(null);
  const [stbFileName, setStbFileName] = useState(null);
  const [purchaseFileName, setPurchaseFileName] = useState('');
  const [transferFileName, setTransferFileName] = useState('');
  const [sellFileName, setSellFileName] = useState('');
  const [loadingSpinner, setLoadingSpinner] = useState(true);
  const [isDefaultCurrency, setIsDefaultCurrency] = useState(false);
  const [localStart, setLocalStart] = React.useState<any>(new Date('2018-01-01T19:30:00.000Z'));
  const [localEnd, setLocalEnd] = React.useState<any>(new Date('2018-01-01T17:29:00.000Z'));

  const printRef = useRef();
  const notificationTemplate = notificationTemplates?.filter(noti => noti.id===15)[0]; // TODO what does 15 mean? And why 15?
  const createdByBankStaff = quotationEntity?.branch;
  const emptyUser = defaultUser;

  const [existingBursaBidData, setExistingBursaBidData] = useState(null);
  const [existingBursaOtcData, setExistingBursaOtcData] = useState(null);
  const [existingBursaStbData, setExistingBursaStbData] = useState(null);

  const serverStatus = useMemo(() => {
    if (!comexSettingsEntity) {
      return false;
    }

    if (quotationEntity?.comexCreated === false) {
      return comexSettingsEntity?.apiServerStatus === true;
    }

    return comexSettingsEntity?.serverStatus === true;
  }, [comexSettingsEntity, quotationEntity]);

  const checkLocalCommodity = (commodity: ICommodity | undefined) => {
    return commodity?.isActive === true && commodity?.ownership === 'Local';
  };
  const isLocalCommodity = checkLocalCommodity(quotationEntity?.commodity);


  useEffect(() => {
    if (account?.authorities.includes(AUTHORITIES.SUBADMIN_BANK)) {
      dispatch(getUserRoleAccessByUserId(account?.id));
    }
  }, [account]);

  useEffect(() => {
    if (account?.login) {
      dispatch(getComexSetting(1));
      dispatch(getEntityWithoutPending(props.match.params.id));
      dispatch(getNotificationTemplates({}));
      dispatch(getAllAlshmokhAdminUsers());
      dispatch(getBursaEmails({}));
      dispatch(getAllAlshmokhStaffUsers());
    }
  }, [account]);
  useEffect(() => {
    // get user_id for notification record
    (quotationEntity?.createdBy !== undefined && quotationEntity?.createdBy !== "system") && dispatch(getUserByLogin(quotationEntity?.createdBy));
    quotationEntity?.branch?.id !== undefined && dispatch(getBranchManagerUser(quotationEntity?.branch?.id));

    // set data for form
    setPoNumberData(
      isLocalCommodity
        ? (quotationEntity?.purchaseOrder?.poNumber || '-')
        : (quotationEntity?.bursaAPIBidCertId === null ? '-' : quotationEntity?.bursaAPIBidCert?.ecertNo || '')
    );
    setPoCreatedDateData(quotationEntity?.purchaseOrder ? moment(quotationEntity?.purchaseOrder?.createdDate).local().format('yyyy/MM/DD HH:mm:ss') : moment(quotationEntity?.createdDate).local().format('yyyy/MM/DD HH:mm:ss') || '');

    const freshIsDefaultCurrency =
      (quotationEntity?.bank?.feeCurrency?.toLowerCase() ?? '') === 'bank default currency'.toLowerCase();
    setIsDefaultCurrency(freshIsDefaultCurrency);

    setAmountData(quotationEntity?.amount?.toLocaleString() || '');
    setCommodityNameData(quotationEntity?.commodity?.name || '');
    setDescriptionData(quotationEntity?.description || '');
    setCommodityUnitPriceData(quotationEntity?.commodityUnitPrice?.toLocaleString() || '');
    setCommodityQuantityData(quotationEntity?.commodityQuantity?.toLocaleString() || '');
    setCommodityUnitData(quotationEntity?.commodityUnit || 'Ton');

    // Display-only override: show the real configured Lump Sum fee amount instead of the
    // backend's rounded value already persisted on quotationEntity.
    const isLocal = quotationEntity?.commodity?.ownership === 'Local';
    const isCommissionMode = isCommissionModeForBank(isLocal, quotationEntity?.bank);
    const currencyIdForFiltering = resolveCurrencyIdForFiltering(freshIsDefaultCurrency, quotationEntity?.bank?.currencyId, quotationEntity?.currencyIndexId);
    const displayTransactionFee = isCommissionMode
      ? null
      : resolveLumpSumFeeAmount(bankFeeList, quotationEntity?.amount, currencyIdForFiltering);
    const quotationCurrencyFilterId = resolveCurrencyIdForFiltering(!freshIsDefaultCurrency, currencyIdForFiltering, quotationEntity?.currencyIndexId);
    const displayFeeInQuotationCurrency = isCommissionMode
      ? null
      : resolveLumpSumFeeAmount(bankFeeList, quotationEntity?.amount, quotationCurrencyFilterId);

    if (displayTransactionFee !== null) {
      setTransactionFeeData(displayTransactionFee.toLocaleString());
    } else if (quotationEntity?.transactionFee !== null && quotationEntity?.transactionFee !== undefined) {
      setTransactionFeeData(quotationEntity?.transactionFee?.toLocaleString()|| '');
    } else {
      const fee = quotationEntity?.fee;
      const commission = quotationEntity?.commission;
      const transactionFee = fee + commission;
      setTransactionFeeData(transactionFee.toLocaleString());
    }
    setFeeInQuotationCurrencyData(
      (displayFeeInQuotationCurrency ?? quotationEntity?.feeInQuotationCurrency)?.toLocaleString() || ''
    );
    setTotalAmountData(quotationEntity?.totalAmount?.toLocaleString() || '');
    setCustomerICData(quotationEntity?.customer?.ic || '');
    setCustomerNameData(quotationEntity?.customer?.name || '');
    setCustomerNameArData(quotationEntity?.customer?.nameArabic || '');
    setCustomerNationalityData(quotationEntity?.customer?.nationality || '');
    setCustomerTelData(quotationEntity?.customer?.tel || '');
    setCustomerEmailData(quotationEntity?.customer?.email || '');
    setBranchCustomerApproval(quotationEntity?.branch?.customerApproval);
  }, [quotationEntity, bankFeeList]);

  useEffect(() => {
    if (quotationEntity?.bank?.id && quotationEntity?.commodity) {
      const commodityType = quotationEntity.commodity.ownership === 'Local' ? 'Local' : 'International';
      dispatch(getFeeListByBankIdAndCommodityType({ bankId: quotationEntity.bank.id, commodityType }));
    }
  }, [quotationEntity?.bank?.id, quotationEntity?.commodity?.ownership]);

  useEffect(() => {
    if (account?.login !== undefined) {
      const userTimeZone = moment.tz.guess();
      const operationStartMalayTime = moment.utc(comexSettingsEntity?.operationStartTime).tz('Asia/Kuala_Lumpur');
      const operationEndMalayTime = moment.utc(comexSettingsEntity?.operationEndTime).tz('Asia/Kuala_Lumpur');
      const operationStartLocalTime = moment(operationStartMalayTime).tz(userTimeZone);
      const operationEndLocalTime = moment(operationEndMalayTime).tz(userTimeZone);
      setLocalStart(operationStartLocalTime.toDate());
      setLocalEnd(operationEndLocalTime.toDate());

      if (isLocalCommodity !== undefined && !isLocalCommodity && isFriday && isDuringFridayPrayer()) {
        setOperationTime(false);
        return;
      }

      const currentMalayTime = moment().tz('Asia/Kuala_Lumpur');
      const startTime = moment(currentMalayTime).set({
        hour: operationStartMalayTime.hour(),
        minute: operationStartMalayTime.minute(),
      });

      const endTime = moment(currentMalayTime).set({
        hour: operationEndMalayTime.hour(),
        minute: operationEndMalayTime.minute(),
      });

      if(isLocalCommodity){
        setOperationTime(true);
      } else {
        if (currentMalayTime.isBetween(startTime, endTime, null, '[]')) {
          setOperationTime(true);
        } else {
          setOperationTime(false);
        }
      }
    }
  }, [comexSettingsEntity, quotationEntity]);



  useEffect(() => {
    if (quotationEntity?.customer?.ic !== undefined && Number(quotationEntity?.customer?.ic) !== 0)
      Promise.all([dispatch(getUserByAlshmokhAdmin(quotationEntity?.customer?.ic))]);
  }, [quotationEntity?.customer]);

  useEffect(() => {
    if (purchaseCancellation?.managerId !== undefined && Number(purchaseCancellation?.managerId) !== 0)
      dispatch(getUserByIdAsOtherRoles(Number(purchaseCancellation?.managerId))).then(res => setManager(res.payload['data']));

    if (purchaseCancellation?.comexAdminId !== undefined && Number(purchaseCancellation?.comexAdminId) !== 0)
      dispatch(getUserByIdAsOtherRoles(Number(purchaseCancellation?.comexAdminId)));
  }, [purchaseCancellation]);

  useEffect(() => {
    quotationEntity?.cancelOrder === true &&
    (account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER) ||
      account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
      account?.authorities?.includes(AUTHORITIES.BANK_STAFF) ||
      account?.authorities?.includes(AUTHORITIES.AUDITOR) ||
      account?.authorities?.includes(AUTHORITIES.AREA_MANAGER) ||
      account?.authorities?.includes(AUTHORITIES.BANK_MANAGER) ||
      account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)) && quotationEntity?.id &&
    dispatch(getPurchaseCancellationByQuoId(quotationEntity?.id));
  }, [quotationEntity?.id]);

  useEffect(() => {
    if (quotationEntity?.bursaAPIBidCertId === null) {
      setIsBidId(false);
    } else {
      setIsBidId(true);
    }

    if (quotationEntity?.bursaAPIOtcCertId === null) {
      setIsOtcId(false);
    } else {
      setIsOtcId(true);
    }

    if (quotationEntity?.bursaAPIStbCertId === null) {
      setIsStbId(false);
    } else {
      setIsStbId(true);
    }
  }, [quotationEntity?.id]);

  const handleToSubmit = () => {
    if (transferInProgressRef.current || isProcessingTransfer) return;
    // Validate Agreement of Transfer:
    // branchCustomerApproval=true means checkbox is shown and user must check it
    // branchCustomerApproval=false/null means branch does not require it (auto-approved)
    const requiresAgreement = branchCustomerApproval === true;
    if (requiresAgreement && checkedCustomerApproval === false) {
      setErrCustApprovalRoleMsg(translate('comexApp.quotation.customerApproval.errorMessage'));
      return; // do NOT set isProcessingTransfer — nothing started yet
    }
    transferInProgressRef.current = true;
    setIsProcessingTransfer(true);
    {
      setCheckedCustomerApproval(true);
      // Skip SMS dialog when customer login is disabled for this bank
      if (quotationEntity?.bank?.enableCustomerLogin === false) {
        const updatedQuotationEntity = {
          ...quotationEntity,
          status: 'Transferred',
          bankCustomerApproval: true,
          smsLanguage: 'EN',
          smsSent: true,
        };
        dispatch(updateEntity(updatedQuotationEntity)).then(res => {
          if ((res as any)?.error?.response?.status === 409) {
            transferInProgressRef.current = false;
            setIsProcessingTransfer(false);
            setSlotAlreadyProcessing('transfer');
            return;
          }
          transferInProgressRef.current = false;
          setIsProcessingTransfer(false);
          setIsTransferRequested(true);
          goBackToHomeTransfer();
        });
      } else {
        setOpenSMSModal(true);
      }
    }
  };

  useEffect(() => {
    if (errCustApprovalMsg) {
      setErrCustApprovalRoleMsg(translate('comexApp.quotation.customerApproval.errorMessage'));
    }
  }, [Storage.session.get('locale'), errCustApprovalMsg]);

  const saveEntity = () => {
    if (isConfirmingTransfer) return;
    setIsConfirmingTransfer(true);
    dispatch(getEntityWithoutPending(props.match.params.id)).then(res => {
      setOpenSMSModal(false);
      setLoading(false);

      const data = res.payload['data'];

      const shouldUpdateBecauseBoughtAndNullSMS =
        data.status === "Bought" &&
        data.smsLanguage === null &&
        account?.authorities.includes(AUTHORITIES.BANK_STAFF) &&
        openSMSModal === true;

      const shouldUpdateDueToMissingOTCCertAfterSMSSent =
        data.status === 'Transferred' &&
        data.smsLanguage !== null &&
        data.smsSent === true &&
        data.bursaAPIOtcCertId === null &&
        data.localCommodityOtcCertId === null &&
        openSMSModal === true;

      if (shouldUpdateBecauseBoughtAndNullSMS || shouldUpdateDueToMissingOTCCertAfterSMSSent) {
        localStorage.setItem('showErrorDialog', 'false');
        const updatedQuotationEntity = {
          ...quotationEntity,
          status: "Transferred",
          bankCustomerApproval: checkedCustomerApproval,
          smsLanguage: SMSLanguage,
          smsSent: true,
        }
        dispatch(updateEntity(updatedQuotationEntity)).then(updateQuoEntity => {
          if ((updateQuoEntity as any)?.error?.response?.status === 409) {
            transferInProgressRef.current = false;
            setIsProcessingTransfer(false);
            setIsConfirmingTransfer(false);
            setSlotAlreadyProcessing('transfer');
            return;
          }
          transferInProgressRef.current = false;
          setIsProcessingTransfer(false);
          setIsConfirmingTransfer(false);
          if (updateQuoEntity?.payload["response"]) {
            const status = updateQuoEntity?.payload["response"].data?.status;
            if (status === 500) {
              localStorage.setItem('showErrorDialog', 'true');
              localStorage.setItem('errorMessage', updateQuoEntity?.payload["response"].data?.title);
            }
          }
          setIsTransferRequested(true);
          const event = new Event('localStorageUpdate');
          window.dispatchEvent(event);
          goBackToHomeTransfer();
        });
      } else {
        setOpenSMSModal(false);
        setLoading(true);
        transferInProgressRef.current = false;
        setIsProcessingTransfer(false);
        setIsConfirmingTransfer(false);
      }
    });
  };

  const handleAmendClick = () => {
    (quotationEntity?.stbOption === 'Keep' && quotationEntity?.cancelOrder === null) ? setIsKeepDialogOpen(true) : setIsDialogOpen(true)
    if (account?.authorities.includes(AUTHORITIES.SUBADMIN_KEEP) || account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN)) {
      const alshmokhAdminAcc=alshmokhAdminUsers?.find(alshkhAdmin => alshkhAdmin.id===purchaseCancellation?.comexAdminId);
      if(alshmokhAdminAcc!==undefined)
        setAlshmokhAdmin(alshmokhAdminAcc);
      else{
        const alshmokhStaffAcc=alshmokhStaffUsers?.find(alshkhStaff => alshkhStaff.id===purchaseCancellation?.comexAdminId);
        setAlshmokhAdmin(alshmokhStaffAcc);
      }
    }
    if (purchaseCancellation.comexAdminId !== null) {
      if (account?.authorities.includes(AUTHORITIES.SUBADMIN_CANCELLATION)) {
        setAlshmokhAdmin(account);
      }
    }
  };

  const updateDocCallback = () =>{
    dispatch(getEntityWithoutPending(props.match.params.id));
  }

  const handleRequestCancellationClick = () => {
    setIsDialogOpen(true)
  };

  const sendCancelApprovedEmails = () => {
    const notifTemplateCancelApprovedAdmin = notificationTemplates?.filter((temp) => temp.type === "poCancelApprovedAlshmokh")[0];
    if (bursaEmails) {
      bursaEmails.forEach(email => {
        const temp_msg1 = notifTemplateCancelApprovedAdmin.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo);

        const sendEmailBursa = {
          user: { ...emptyUser, email: email.emailAddress, login: email.emailAddress },
          notificationTemplate: {
            ...notifTemplateCancelApprovedAdmin,
            message: temp_msg1
          },
          orderId: isLocalCommodity
            ? quotationEntity?.localCommodityBidCert?.ecertNo?.toString()
            : quotationEntity?.bursaAPIBidCert?.ecertNo?.toString(),
          productCode: quotationEntity?.commodity?.name,
          clientName: quotationEntity?.customer?.name,
          purchaseDate: moment(quotationEntity?.createdDate).tz('Asia/Kuala_Lumpur').format("yyyy/MM/DD HH:mm:ss"),
          bankBranchName: `${quotationEntity?.bank?.name}/${quotationEntity?.branch?.name}`,
          reason: requestCancellationReason,
        };

        dispatch(sendPoCancelEmail(sendEmailBursa));
      });
    }
  };

  const handleRequestCancellation = () => {
    setCancel(true);
    if (requestCancellationReason.length > 0) {
      setRequestCancel(true);
      const updatedQuotationEntity = {
        ...quotationEntity,
        status: 'CANCELLED',
        cancelOrder: true,
      }
      dispatch(updateEntity(updatedQuotationEntity));
      const purchaseCancellationValue = {
        reason: requestCancellationReason,
        managerApproval: true,
        comexAdminApproval: true,
        status: "",
        result: "CANCELLED",
        quotation: quotationEntity,
      }
      dispatch(createPurchaseCancellation(purchaseCancellationValue));
      const notifTemplateCancelRequested = notificationTemplates?.filter((temp) => temp.type === "poCancelRequested")[0];
      const notificationTemplateValueKeep = {
        id: notifTemplateCancelRequested.id,
        type: notifTemplateCancelRequested.type,
        medium: notifTemplateCancelRequested.medium,
        language: notifTemplateCancelRequested.language,
        message: notifTemplateCancelRequested.message,
      }

      branchManagerAccounts.forEach(branchManagerAccount=> {
        const notiEntityRequestCancel = {
          message: notifTemplateCancelRequested.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
          status: "Send",
          customerID: quotationEntity?.customer.id,
          dismissed: false,
          userID: branchManagerAccount?.id,
          quotationId: quotationEntity?.id,
          notificationTemplate: notificationTemplateValueKeep,
        }
        dispatch(createNotification(notiEntityRequestCancel));
      });
      if(!isLocalCommodity) {
        console.warn("send")
        sendCancelApprovedEmails();
      }
      setTimeout(() => {
        setLoading(true);
      }, 3000);
    } else {
      setErrorText(translate('comexApp.quotation.cancellationModal.required'));
      setValidateCancellation(true);
    }

  };

  useEffect(() => {
    if (Storage.session.get('locale') === 'ar-ly'
      && descriptionData !== ''
      && descriptionData !== undefined
      && itemDescriptionInArabic === '') {
      const data = {
        q: descriptionData,
        source: 'en',
        target: 'ar',
        api_key: ''
      };
      axios.post(`https://translate.argosopentech.com/translate`, data)
        .then((response) => {
          setItemDescriptionInArabic(response?.data?.translatedText);
        });
    }
  }, [descriptionData]);

  const handleApproveCancellation = () => {
    let updatedCancellationEntity;

    if (account?.authorities.includes(AUTHORITIES.BRANCH_MANAGER)) {
      setApproveByBranch(true);
      updatedCancellationEntity = {
        ...purchaseCancellation,
        managerApproval: true,
        managerId: account?.id,
        result: "APPROVED"
      };
      const notifTemplateCancelApprovedBranch = notificationTemplates?.filter((temp) => temp.type === "poCancelApprovedBranch")[0];
      const notificationTemplateValueCancelApprovedBranch = {
        id: notifTemplateCancelApprovedBranch.id,
        type: notifTemplateCancelApprovedBranch.type,
        medium: notifTemplateCancelApprovedBranch.medium,
        language: notifTemplateCancelApprovedBranch.language,
        message: notifTemplateCancelApprovedBranch.message,
      }
      if (alshmokhAdminUsers !== null && alshmokhAdminUsers !== undefined) {
        alshmokhAdminUsers?.map((admin) => {
          const notiEntityApproveByBranch = {
            message: notifTemplateCancelApprovedBranch.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
            // message: "Cancellation requested for order "+quotationEntity?.purchaseOrder?.poNumber,
            status: "Send",
            customerID: quotationEntity?.customer?.id,
            dismissed: false,
            userID: admin?.id,
            quotationId: quotationEntity?.id,
            notificationTemplate: notificationTemplateValueCancelApprovedBranch,
          }
          dispatch(createNotification(notiEntityApproveByBranch));
        })
      }
      if (alshmokhStaffUsers !== null && alshmokhStaffUsers !== undefined) {
        const filteredAlshmokhStaffUsers = alshmokhStaffUsers?.filter((staff) => staff.authorities.includes(AUTHORITIES.SUBADMIN_CANCELLATION));
        filteredAlshmokhStaffUsers.map((staff) => {
          const notiEntityApproveByBranch = {
            message: notifTemplateCancelApprovedBranch.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
            // message: "Cancellation requested for order "+quotationEntity?.purchaseOrder?.poNumber,
            status: "Send",
            customerID: quotationEntity?.customer?.id,
            dismissed: false,
            userID: staff?.id,
            quotationId: quotationEntity?.id,
            notificationTemplate: notificationTemplateValueCancelApprovedBranch,
          }
          dispatch(createNotification(notiEntityApproveByBranch));
        })
      }
    }
    else if (purchaseCancellation.managerApproval === true && purchaseCancellation.comexAdminApproval === null) {
      setCancel(true);
      const updatedQuotationEntity = {
        ...quotationEntity,
        cancelOrder: true,
      }
      updatedCancellationEntity = {
        ...purchaseCancellation,
        comexAdminApproval: true,
        comexAdminId: account?.id,
        result: "APPROVED"
      }
      dispatch(updateEntity(updatedQuotationEntity));
      const notifTemplateCancelApprovedAdmin = notificationTemplates?.filter((temp) => temp.type === "poCancelApprovedAlshmokh")[0];
      branchManagerAccounts.forEach(branchManagerAccount=> {
        const notiEntityApproveByAdminToBranch = {
          message: notifTemplateCancelApprovedAdmin.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
          // message: "Cancellation requested for order "+quotationEntity?.purchaseOrder?.poNumber,
          status: "Send",
          customerID: quotationEntity?.customer.id,
          dismissed: false,
          userID: branchManagerAccount?.id,
          quotationId: quotationEntity?.id,
          notificationTemplate: notifTemplateCancelApprovedAdmin,
        }
        dispatch(createNotification(notiEntityApproveByAdminToBranch));
      });
      const notiEntityApproveByAdminToStaff = {
        message: notifTemplateCancelApprovedAdmin.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
        // message: "Cancellation requested for order "+quotationEntity?.purchaseOrder?.poNumber,
        status: "Send",
        customerID: quotationEntity?.customer.id,
        dismissed: false,
        userID: bankStaffAccount?.id,
        quotationId: quotationEntity?.id,
        notificationTemplate: notifTemplateCancelApprovedAdmin,
      }
      dispatch(createNotification(notiEntityApproveByAdminToStaff));

      bursaEmails?.map(email => {
        const temp_msg1 = notifTemplateCancelApprovedAdmin.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo);

        const sendEmailBursa = {
          user: { ...emptyUser, email: email.emailAddress, login: email.emailAddress },
          notificationTemplate: {
            ...notifTemplateCancelApprovedAdmin,
            message: temp_msg1
          },
          orderId: quotationEntity?.bursaAPIBidCert?.ecertNo?.toString(),

          productCode: quotationEntity?.commodity?.name,
          clientName: quotationEntity?.customer?.name,
          purchaseDate: moment(quotationEntity?.createdDate).tz('Asia/Kuala_Lumpur').format("yyyy/MM/DD HH:mm:ss"),
          // purchaseDate: new Date(quotationEntity.createdDate).getDate()+"-"+(new Date(quotationEntity.createdDate).getMonth()+1)+"-"+new Date(quotationEntity.createdDate).getFullYear(),
          bankBranchName: quotationEntity?.bank?.name + "/" + quotationEntity?.branch?.name,
          reason: purchaseCancellation.reason,
        }
        dispatch(sendPoCancelEmail(sendEmailBursa));
      })
      setTimeout(() => {
        setLoading(true);
      }, 3000);
    } else if (purchaseCancellation.comexAdminApproval === true) {
      setCancel(true);
      const updatedQuotationEntity = {
        ...quotationEntity,
        status: 'CANCELLED',
        cancelOrder: true,
      }
      updatedCancellationEntity = {
        ...purchaseCancellation,
        comexAdminApproval: true,
        comexAdminId: account?.id,
        result: "CANCELLED"
      }
      dispatch(updateEntity(updatedQuotationEntity));
      const notifTemplateCancelBursaApproved = notificationTemplates?.filter((temp) => temp.type === "poCancelBursaApproved")[0];

      branchManagerAccounts.forEach(branchManagerAccount=> {
        const notiEntityBursaApprovedToBranch = {
          message: notifTemplateCancelBursaApproved.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
          status: "Send",
          customerID: quotationEntity?.customer.id,
          dismissed: false,
          userID: branchManagerAccount?.id,
          quotationId: quotationEntity?.id,
          notificationTemplate: notifTemplateCancelBursaApproved,
        }
        dispatch(createNotification(notiEntityBursaApprovedToBranch));
      });
      const notiEntityBursaApprovedToStaff = {
        message: notifTemplateCancelBursaApproved.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
        status: "Send",
        customerID: quotationEntity?.customer.id,
        dismissed: false,
        userID: bankStaffAccount?.id,
        quotationId: quotationEntity?.id,
        notificationTemplate: notifTemplateCancelBursaApproved,
      }
      dispatch(createNotification(notiEntityBursaApprovedToStaff));
      setTimeout(() => {
        setLoading(true);
      }, 3000);
    }
    dispatch(updatePurchaseCancellation(updatedCancellationEntity));
  };


  const handleDenyCancellation = () => {
    setCancelDeny(true);
    let updatedCancellationEntity;
    if (account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER)) {
      updatedCancellationEntity = {
        ...purchaseCancellation,
        managerApproval: false,
        managerId: account?.id,
        result: "DENIED"
      }
    } else {
      updatedCancellationEntity = {
        ...purchaseCancellation,
        comexAdminApproval: false,
        comexAdminId: account?.id,
        result: "DENIED"
      }
      if ( purchaseCancellation.comexAdminApproval === true && (account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) || account?.authorities.includes(AUTHORITIES.SUBADMIN_CANCELLATION)) ) {
        const notifTemplateCancelBursaDenied = notificationTemplates?.filter((temp) => temp.type === "poCancelBursaDenied")[0];

        branchManagerAccounts.forEach(branchManagerAccount=> {
          const notiEntityBursaDeniedToBranch = {
            message: notifTemplateCancelBursaDenied.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
            status: "Send",
            customerID: quotationEntity?.customer.id,
            dismissed: false,
            userID: branchManagerAccount?.id,
            quotationId: quotationEntity?.id,
            notificationTemplate: notifTemplateCancelBursaDenied,
          }
          dispatch(createNotification(notiEntityBursaDeniedToBranch));
        });
        const notiEntityBursaDeniedToStaff = {
          message: notifTemplateCancelBursaDenied.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
          status: "Send",
          customerID: quotationEntity?.customer.id,
          dismissed: false,
          userID: bankStaffAccount?.id,
          quotationId: quotationEntity?.id,
          notificationTemplate: notifTemplateCancelBursaDenied,
        }
        dispatch(createNotification(notiEntityBursaDeniedToStaff));
      }
    }
    dispatch(updatePurchaseCancellation(updatedCancellationEntity));
    const updatedQuotationEntity = {
      ...quotationEntity,
      cancelOrder: false,
    }
    dispatch(updateEntity(updatedQuotationEntity));
  };

  // For IBAN Number
  const ibanEntity = useAppSelector(state => state.iban.entity);
  const qId = props.match.params.id;
  useEffect(() => {
    if (isLocalCommodity) {
      dispatch(getEntityByQuotationId(qId));
    }
  }, [isLocalCommodity, qId]);

  const [ openIBANModal, setOpenIBANModal ] = useState(false);
  const [ selectedIBANOption, setSelectedIBANOption ] = useState('later');
  const [ ibanValue, setIbanValueValue ] = useState('');
  const [ ibanButtonActionType, setIbanButtonActionType ] = useState<string | null>(null);
  const [isSubmittingIban, setIsSubmittingIban] = useState(false);

  const handleIBANInputChange = (event) => { setIbanValueValue(event.target.value || ''); };
  const handleIBANRadioChange = (event) => { setSelectedIBANOption(event.target.value); };

  const isValidIBANNumber = () => { return ibanValue.length > 0 && ibanValue.length !== 30;};
  const getIBANHelperText = () => { return ibanValue.length > 0 && ibanValue.length !== 30 ? "IBAN number should be exactly 30 digits long." : "";};

  const handleIBANModal = (buttonType) => {
    setOpenIBANModal(!openIBANModal);
    setIbanButtonActionType(buttonType);
    setIsSubmittingIban(false);
    if(buttonType === 'EDIT') {
      setIbanValueValue(ibanEntity?.ibanNumber || '');
      setSelectedIBANOption('ibanNumber');
    } else if (buttonType === 'CLOSE') {
      setIbanValueValue('');
      setSelectedIBANOption('later');
    }
  }
  const handleIBANOption = async () => {
    if (selectedIBANOption === 'ibanNumber' && ibanValue !== null) {
      // Prevent double submission
      if (isSubmittingIban) {
        return;
      }

      setIsSubmittingIban(true);

      try {
        // Always fetch the latest state
        const res = await dispatch(getEntityByQuotationId(quotationEntity?.id));
        const latestIban = res.payload['data'];

        if (latestIban?.id && ibanButtonActionType !== 'EDIT') {
          // IBAN already exists
          alert(translate("comexApp.quotation.ibanExists"));
          setIsSubmittingIban(false);
          return;
        }

        // TO SAVE IBAN
        const ibanToSave: IIban = {
          ibanNumber: ibanValue,
          customerId: quotationEntity?.customer?.id,
          quotationId: quotationEntity?.id,
          ibanBankName: quotationEntity?.bank?.name || '',
          ibanBranchName: quotationEntity?.branch?.name || '',
        };

        if (ibanEntity?.id) {
          await dispatch(updateIban(ibanToSave));
        } else {
          await dispatch(createEntity(ibanToSave));
        }

        // Refresh IBAN data after save
        await dispatch(getEntityByQuotationId(quotationEntity?.id));

      } catch (error) {
        console.error('Error saving IBAN:', error);
      } finally {
        setIsSubmittingIban(false);
      }
    }
  };

  const handleIBANConfirm = async () => {

    if (selectedIBANOption === 'ibanNumber' && !ibanValue.trim()) {
      return;
    }

    // Prevent double click
    if (isSubmittingIban) {
      return;
    }

    // SELL, CLOSE, ADDING-LATE
    // quotation-bought -> sell -> add IBAN -> database
    // 			            -> Later
    //
    // qoutation-bought -> sold -> if added -> show with textbox
    // 			            -> if later -> add IBAN -> database
    setOpenIBANModal(false);
    if(ibanButtonActionType === 'SELL') {
      await handleIBANOption();
      handleSell();
    }
    if(ibanButtonActionType === 'ADDING-LATE' || ibanButtonActionType === 'EDIT') {
      await handleIBANOption();
    }
  }

  const renderIban = () => {
    if (isLocalCommodity) {
      return <IbanForm ibanEntity={ibanEntity} />;
    }

    return null;
  }

  const handleSell = () => {
    if (sellInProgressRef.current || isProcessingSell) return;
    sellInProgressRef.current = true;
    setIsProcessingSell(true);
    dispatch(getEntityWithoutPending(props.match.params.id)).then(res => {
      if ((res.payload['data'].status === "Transferred" && res.payload['data'].stbOption === null) ||
        (res.payload['data'].status === "Sold" && res.payload['data'].stbOption !== null && res.payload['data'].bursaAPIStbCertId === null && res.payload['data'].localCommodityStbCertId === null) ||
        (res.payload['data'].status === "Kept" && res.payload['data'].comexAdminDecision === null)) {
        localStorage.setItem('showErrorDialog', 'false');
        setLoading(false);
        setLoadingSpinner(false);
        if ( (isLocalCommodity
            ? (account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
              account?.authorities.includes(AUTHORITIES.BANK_STAFF) ||
              account?.authorities.includes(AUTHORITIES.SUBADMIN_KEEP))
            : (account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
              account?.authorities.includes(AUTHORITIES.SUBADMIN_KEEP)) ) && quotationEntity?.stbOption === 'Keep' && isSold === false) {
          const updatedQuotationEntity = {
            ...quotationEntity,
            status: 'Sold',
            comexAdminDecision: 'Sell',
            isTransactionLocked: null,
            lockedByShserId: null,
          }
          setIsKeepDialogOpen(false);
          if (customerAccount ) {
            dispatch(handleRegister({
              login: quotationEntity?.customer?.ic,
              password: "customer",
              email: quotationEntity?.customer?.email,
              firstName: quotationEntity?.customer?.name,
              authorities: [AUTHORITIES.CUSTOMER],
            }));
          }
          dispatch(updateEntity(updatedQuotationEntity)).then(updateQuoEntity => {
            sellInProgressRef.current = false;
            setIsProcessingSell(false);
            setLoading(true);
            setLoadingSpinner(true);
            if (updateQuoEntity?.payload["response"]) {
              if (updateQuoEntity?.payload["response"].data?.status === 500) {
                localStorage.setItem('showErrorDialog', 'true');
                localStorage.setItem('errorMessage', updateQuoEntity?.payload["response"].data?.title);
              }
            }
            setIsSold(true);
            const event = new Event('localStorageUpdate');
            window.dispatchEvent(event);
          });

        }
        else if ((account?.authorities.includes(AUTHORITIES.CUSTOMER) || account?.authorities.includes(AUTHORITIES.BANK_STAFF)
            || account?.authorities.includes(AUTHORITIES.SELL_APPROVAL)
          )
          && (quotationEntity?.stbOption === null || quotationEntity?.stbOption === 'Sell') && isSold === false) {
          localStorage.setItem('showErrorDialog', 'false');
          const updatedQuotationEntity = {
            ...quotationEntity,
            status: 'Sold',
            stbOption: 'Sell',
          }
          dispatch(updateEntity(updatedQuotationEntity)).then(updateQuoEntity => {
            if ((updateQuoEntity as any)?.error?.response?.status === 409) {
              sellInProgressRef.current = false;
              setIsProcessingSell(false);
              setSlotAlreadyProcessing('sell');
              return;
            }
            sellInProgressRef.current = false;
            setIsProcessingSell(false);
            setLoading(true);
            setLoadingSpinner(true);
            if (updateQuoEntity?.payload["response"]) {
              if (updateQuoEntity?.payload["response"].data?.status === 500) {
                localStorage.setItem('showErrorDialog', 'true');
                localStorage.setItem('errorMessage', updateQuoEntity?.payload["response"].data?.title);
              }
            }
            setIsSold(true);
            const event = new Event('localStorageUpdate');
            window.dispatchEvent(event);
          });
        }
        setIsSold(true);
        const event = new Event('localStorageUpdate');
        window.dispatchEvent(event);
      } else {
        setIsKeepDialogOpen(false);
        setLoading(true);
        res.payload['data'];
      }
    });
  };

  const handleKeep = () => {

    if (( isLocalCommodity
          ? (account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
            account?.authorities?.includes(AUTHORITIES.BANK_STAFF) ||
            account?.authorities.includes(AUTHORITIES.SUBADMIN_KEEP))
          : (account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
            account?.authorities.includes(AUTHORITIES.SUBADMIN_KEEP)) ) &&
      quotationEntity?.stbOption === 'Keep' &&
      quotationEntity?.comexAdminDecision === null && keepCus === false) {
      const updatedQuotationEntity = {
        ...quotationEntity,
        comexAdminDecision: 'Keep',
        keepApproveDate: new Date().toISOString(),
        keepApproveUserId: account?.id,
        isTransactionLocked: null,
        lockedByShserId: null,
      }
      setIsKeepDialogOpen(false);
      dispatch(updateEntity(updatedQuotationEntity));

    } else if ((account?.authorities.includes(AUTHORITIES.CUSTOMER) ||
        account?.authorities.includes(AUTHORITIES.BANK_STAFF) ) &&
      quotationEntity?.stbOption === null && keepCus === false) {

      const notifTemplateKeep = notificationTemplates?.filter((temp) => temp.type === "poKeepRequested")[0];
      const notificationTemplateValueKeep = {
        id: notifTemplateKeep.id,
        type: notifTemplateKeep.type,
        medium: notifTemplateKeep.medium,
        language: notifTemplateKeep.language,
        message: notifTemplateKeep.message,
      }
      if ( alshmokhAdminUsers !== null && alshmokhAdminUsers !== undefined) {
        alshmokhAdminUsers?.map((admin) => {

          const notiEntityKeepAlshmokhAdmin = {
            message: notifTemplateKeep.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
            status: "Sent",
            customerID: quotationEntity?.customer?.id,
            dismissed: false,
            userID: admin?.id,
            quotationId: quotationEntity?.id,
            notificationTemplate: notificationTemplateValueKeep,
          }
          dispatch(createNotification(notiEntityKeepAlshmokhAdmin));
        });
      }

      if (alshmokhStaffUsers !== null && alshmokhStaffUsers !== undefined) {
        const alshmokhStaffWithKeepAuthority = alshmokhStaffUsers?.filter((staff) => staff.authorities.includes(AUTHORITIES.SUBADMIN_KEEP));
        alshmokhStaffWithKeepAuthority?.map((staff) => {
          const notiEntityKeepAlshmokhStaffUser = {
            message: notifTemplateKeep.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo),
            status: "Sent",
            customerID: quotationEntity?.customer?.id,
            dismissed: false,
            userID: staff?.id,
            quotationId: quotationEntity?.id,
            notificationTemplate: notificationTemplateValueKeep,
          }
          dispatch(createNotification(notiEntityKeepAlshmokhStaffUser));
        });
      }


      const updatedQuotationEntity = {
        ...quotationEntity,
        status: 'Kept',
        stbOption: 'Keep',
      }
      dispatch(updateEntity(updatedQuotationEntity));

      // send email notifications
      branchManagerAccounts.forEach(branchManagerAccount => {
        const sendEmailBranchManager = {
          user: branchManagerAccount,
          notificationTemplate: {
            ...notificationTemplate,
            message: notificationTemplate?.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo)
          },
          orderId: quotationEntity?.bursaAPIBidCert?.ecertNo?.toString()
        }
        dispatch(sendEmailKeepRequestedCustomer(sendEmailBranchManager));
      });


      if (account?.authorities.includes(AUTHORITIES.CUSTOMER)) {
        const sendEmailToBankStaff = {
          user: bankStaffAccount,
          notificationTemplate: {
            ...notificationTemplate,
            message: notificationTemplate?.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo)
          },
          orderId: quotationEntity?.bursaAPIBidCert?.ecertNo?.toString()
        }
        dispatch(sendEmailKeepRequestedCustomer(sendEmailToBankStaff));
      }
      if (alshmokhAdminUsers !== null && alshmokhAdmin !== undefined) {
        alshmokhAdminUsers?.map((admin) => {
          const sendEmailAlshmokhAdmin = {
            user: admin,
            notificationTemplate: {
              ...notificationTemplate,
              message: notificationTemplate?.message.replace("{ecertNo}", quotationEntity?.bursaAPIBidCert?.ecertNo)
            },
            orderId: quotationEntity?.bursaAPIBidCert?.ecertNo?.toString()
          }
          dispatch(sendEmailKeepRequestedCustomer(sendEmailAlshmokhAdmin));
        });
      }
    }

    setKeepCus(true);
  };

  // handle button re-purchase
  const handleRepurchase = () => {
    if (purchaseInProgressRef.current || isProcessingPurchase) return;
    purchaseInProgressRef.current = true;
    setIsProcessingPurchase(true);
    dispatch(getEntityWithoutPending(props.match.params.id)).then(res => {
      if (res.payload['data'].purchaseOrderId !== null && res.payload['data'].status === "Bought") {
        setIsRepurchase(true);
        setLoading(true);
        setOpenSMSModal(false);
        if ((account?.authorities?.includes(AUTHORITIES.CUSTOMER) || account?.authorities?.includes(AUTHORITIES.BANK_STAFF)) &&
          quotationEntity?.stbOption === null && quotationEntity?.bursaAPIBidCertId === null && quotationEntity?.localCommodityBidCertId === null) {
          const updatedQuotationEntity = {
            ...quotationEntity,
            ...res.payload['data'],
            stbOption: null,
          }
          dispatch(updateEntity(updatedQuotationEntity)).then(updateRes => {
            if ((updateRes as any)?.error?.response?.status === 409) {
              purchaseInProgressRef.current = false;
              setIsProcessingPurchase(false);
              setSlotAlreadyProcessing('purchase');
              return;
            }
            purchaseInProgressRef.current = false;
            setIsProcessingPurchase(false);
          });
        }
      }
    });
  };


  const getPurchaseColor = () => {
    let color;
    if(isLocalCommodity && quotationEntity?.localCommodityBidCertId !== null)
      color = '#000000'
    else if (!isLocalCommodity && quotationEntity?.bursaAPIBidCertId !== null)
      color = '#000000'
    else
      color = '#D3D3D3'
    return color;
  };

  const getTransferColor = () => {
    let color;
    if(isLocalCommodity && quotationEntity?.localCommodityOtcCertId !== null)
      color = '#000000'
    else if (!isLocalCommodity && quotationEntity?.bursaAPIOtcCertId !== null)
      color = '#000000'
    else
      color = '#D3D3D3'
    return color;
  }

  const getSellColor = () => {
    let color;
    if(isLocalCommodity && quotationEntity?.localCommodityStbCertId !== null)
      color = '#000000'
    else if (!isLocalCommodity && quotationEntity?.bursaAPIStbCertId !== null)
      color = '#000000'
    else
      color = '#D3D3D3'
    return color;
  }

  function shouldRenderButton() {
    return (
      (quotationEntity?.cancelOrder === true &&
        purchaseCancellation.managerApproval === null &&
        account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER)) ||
      (quotationEntity?.stbOption === 'Keep' &&
        quotationEntity?.comexAdminDecision === null &&
        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
          account?.authorities?.includes(AUTHORITIES.SUBADMIN_KEEP))
      ) ||
      (isLocalCommodity &&
        quotationEntity?.stbOption === 'Keep' &&
        quotationEntity?.comexAdminDecision === null &&
        (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
          account?.authorities?.includes(AUTHORITIES.BANK_STAFF) ||
          account?.authorities?.includes(AUTHORITIES.SUBADMIN_KEEP))
      )
    );
  }



  function transferButtons() {
    const otcNotYetDone = isLocalCommodity
      ? quotationEntity?.localCommodityOtcCertId === null
      : quotationEntity?.bursaAPIOtcCertId === null;
    if (operationTime === true && (account?.authorities.includes(AUTHORITIES.BANK_STAFF) || account?.authorities.includes(AUTHORITIES.CUSTOMER)) && otcNotYetDone) {
      return (<Button
          color="primary"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          type="submit"
          onClick={handleToSubmit}
          disabled={
            isProcessingTransfer ||
            updating ||
            (quotationEntity?.bursaAPIBidCertId === null && quotationEntity?.localCommodityBidCertId === null) ||
            (quotationEntity?.bank?.requireDocumentUpload && isLocalCommodity && (!files || files.length === 0))
          }
          hidden={ (serverStatus === false && quotationEntity?.bursaAPIBidCertId !== null && quotationEntity?.bankCustomerApproval === true ) || (isLocalCommodity && account?.authorities.includes(AUTHORITIES.CUSTOMER)) }
        >
          {isProcessingTransfer && <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"/>}
          <Translate contentKey="comexApp.quotation.transferLabel">Transfer</Translate>
        </Button>
      )
    } else {
      return (<Button
          color="primary"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          type="submit"
          disabled
          hidden={(serverStatus === false && quotationEntity?.bursaAPIBidCertId !== null && quotationEntity?.bankCustomerApproval === true) || account?.authorities.includes(AUTHORITIES.ALSHMOKH_USER)}
        >
          <Translate contentKey="comexApp.quotation.transferLabel">Transfer</Translate>
        </Button>
      )
    }
  }

  function keepSellButtons() {
    if (operationTime === true) {
      const isRestrictedRole =
        account?.authorities.includes(AUTHORITIES.ALSHMOKH_USER) ||
        account?.authorities.includes(AUTHORITIES.AREA_MANAGER) ||
        account?.authorities.includes(AUTHORITIES.BRANCH_MANAGER);

      const hasSellApproval = account?.authorities.includes(AUTHORITIES.SELL_APPROVAL);
      const shouldShowSellButton = !isRestrictedRole || hasSellApproval;

      const isAlshmokhUser = account?.authorities.includes(AUTHORITIES.ALSHMOKH_USER);
      const isStbOptionWithServerOffline = quotationEntity?.stbOption !== null &&
        serverStatus === false &&
        !isLocalCommodity &&
        isAlshmokhUser;

      return (<>
          {shouldShowSellButton && (
            <Button
              variant="contained"
              color="primary"
              id="save-entity"
              data-cy="entityCreateSaveButton"
              onClick={handleSell}
              disabled={isProcessingSell || updating}
              hidden={ account?.authorities.includes(AUTHORITIES.BANK_STAFF) &&
                ((isLocalCommodity && quotationEntity?.branch?.sellApprovalLocalCommodity === false) ||
                  (!isLocalCommodity && quotationEntity?.branch?.sellApprovalInternationalCommodity === false)) ||
                isStbOptionWithServerOffline }
            >
              {isProcessingSell && <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"/>}
              <Translate contentKey="comexApp.quotation.sellLabel">Sell</Translate>
            </Button>
          )}
          {((quotationEntity?.stbOption === null && (account?.authorities.includes(AUTHORITIES.BANK_STAFF) || account?.authorities.includes(AUTHORITIES.CUSTOMER) || account?.authorities.includes(AUTHORITIES.SELL_APPROVAL))) || (quotationEntity?.comexAdminDecision !== "KEEP" && account?.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN))) &&
            <Button
              variant="contained"
              color="primary"
              id="save-entity"
              data-cy="entityCreateSaveButton"
              onClick={handleKeep}
              disabled={isProcessingSell || updating}
              hidden={ quotationEntity?.stbOption !== null || (account?.authorities.includes(AUTHORITIES.BANK_STAFF) && (
                (isLocalCommodity && quotationEntity?.branch?.sellApprovalLocalCommodity === false) ||
                (!isLocalCommodity && quotationEntity?.branch?.sellApprovalInternationalCommodity === false)
              )) }
            >
              <Translate contentKey="comexApp.quotation.keepBtnLabel">Keep</Translate>
            </Button>
          }

        </>
      );
    } else {
      return (<>
          <Button
            variant="contained"
            color="primary"
            id="save-entity"
            data-cy="entityCreateSaveButton"
            onClick={handleSell}
            // style={{
            //   marginRight: Storage.session.get('locale') === 'en' ? '3%' : '0',
            //   marginLeft: Storage.session.get('locale') === 'en' ? '0' : '3%'
            // }}
            disabled>
            <Translate contentKey="comexApp.quotation.sellLabel">Sell</Translate>
          </Button>
          <Button
            variant="contained"
            color="primary"
            id="save-entity"
            data-cy="entityCreateSaveButton"
            onClick={handleKeep}
            disabled>
            <Translate contentKey="comexApp.quotation.keepBtnLabel">Keep</Translate>
          </Button>
        </>
      );
    }
  }


  function transferAndKeepSellButtons() {
    const shouldUseBursaAPICertCheck = !isLocalCommodity;

    if ((quotationEntity?.cancelOrder === null || quotationEntity?.cancelOrder === false) &&
      quotationEntity?.bursaAPIOtcCertId === null &&
      (quotationEntity?.status === 'Bought' || quotationEntity?.status === 'Transferred') &&
      quotationEntity?.stbOption === null) {

      if (shouldUseBursaAPICertCheck && quotationEntity?.bursaAPIBidCertId === null) {
        return null;
      }

      if (isLocalCommodity && quotationEntity?.localCommodityStbCertId === null && quotationEntity?.smsLanguage !== null && quotationEntity?.smsSent === true){
        return keepSellButtons();
      }else {
        return transferButtons();
      }

    }

    const stbCertId = isLocalCommodity ? quotationEntity?.localCommodityStbCertId : quotationEntity?.bursaAPIStbCertId;
    if (stbCertId === null &&
      (quotationEntity?.status === 'Transferred' || (quotationEntity?.status === 'Sold' || quotationEntity?.status === 'Kept')) &&
      (quotationEntity?.cancelOrder === null || quotationEntity?.cancelOrder === false) &&
      (account?.authorities.includes(AUTHORITIES.BANK_STAFF) || account?.authorities.includes(AUTHORITIES.CUSTOMER) || account?.authorities.includes(AUTHORITIES.ALSHMOKH_USER) || account?.authorities.includes(AUTHORITIES.AREA_MANAGER) || account?.authorities.includes(AUTHORITIES.BRANCH_MANAGER))) {

      const otcCertId = isLocalCommodity ? quotationEntity?.localCommodityOtcCertId : quotationEntity?.bursaAPIOtcCertId;
      if (otcCertId === null) {
        return null;
      }
      return keepSellButtons();
    }
  }

  // for Resend SMS
  const [openResendSmsDialog, setOpenResendSmsDialog] = useState(false);
  const [resendSmsType, setResendSmsType] = useState('');
  const [localSmsStatus, setLocalSmsStatus] = useState<'success' | 'error' | ''>('');
  const [localSmsError, setLocalSmsError] = useState('');

  const handleResendSmsClose = () => {
    setOpenResendSmsDialog(false);
    setResendSmsType('');
    setLocalSmsStatus('');
    setLocalSmsError('');
  };

  const handleResendTransferSms = async () => {
    setResendSmsType('transfer');
    const resultAction = await dispatch(resendTransferSms(quotationEntity));

    if (resendTransferSms.rejected.match(resultAction)) {
      setLocalSmsStatus('error');
      setLocalSmsError(resultAction.payload['response'].data.error || 'Failed to resend transfer SMS');
      setOpenResendSmsDialog(true);
    } else if (resendTransferSms.fulfilled.match(resultAction)) {
      if (resultAction.payload && resultAction.payload?.status !== 200) {
        setLocalSmsStatus('error');
        setLocalSmsError(resultAction.payload['response'].data.error || 'Failed to resend transfer SMS');
      } else {
        setLocalSmsStatus('success');
        setLocalSmsError('');
      }
      setOpenResendSmsDialog(true);
    }
  };

  const handleResendSoldSms = async () => {
    setResendSmsType('sold');
    const resultAction = await dispatch(resendSoldSms(quotationEntity));
    if (resendSoldSms.rejected.match(resultAction)) {
      setLocalSmsStatus('error');
      setLocalSmsError(resultAction.payload['response'].data.error || 'Failed to resend sold SMS');
      setOpenResendSmsDialog(true);
    } else if (resendSoldSms.fulfilled.match(resultAction)) {
      if (resultAction.payload && resultAction.payload?.status !== 200) {
        setLocalSmsStatus('error');
        setLocalSmsError(resultAction.payload['response'].data.error || 'Failed to resend sold SMS');
      } else {
        setLocalSmsStatus('success');
        setLocalSmsError('');
      }
      setOpenResendSmsDialog(true);
    }
  };

  function resendSmsButtons() {
    const hasStbCert = isLocalCommodity
      ? quotationEntity?.localCommodityStbCertId !== null
      : quotationEntity?.bursaAPIStbCertId !== null;

    const hasOtcCert = isLocalCommodity
      ? quotationEntity?.localCommodityOtcCertId !== null
      : quotationEntity?.bursaAPIOtcCertId !== null;

    if (account?.authorities.includes(AUTHORITIES.CUSTOMER)) {
      return null;
    }

    // Hide resend SMS when customer login is disabled for this bank
    if (quotationEntity?.bank?.enableCustomerLogin === false) {
      return null;
    }

    // Hide resend SMS if customer has no phone number (e.g. created when login was disabled)
    if (!quotationEntity?.customer?.tel || quotationEntity?.customer?.tel.trim() === '') {
      return null;
    }

    if (quotationEntity?.stbOption === 'Sell' &&
      quotationEntity?.status === 'Sold' && hasStbCert) {
      return (
        <Button
          variant="contained"
          color="primary"
          id="resend-sms-sold"
          data-cy="resendSmsSoldButton"
          onClick={handleResendSoldSms}
          disabled={resendSmsLoading}
        >
          <Translate contentKey="comexApp.quotation.resendSMS.resendSmsSoldLabel">Resend Sold SMS</Translate>
        </Button>
      );
    } else if (quotationEntity?.smsLanguage !== null &&
      quotationEntity?.smsSent === true && hasOtcCert) {
      return (
        <Button
          variant="contained"
          color="primary"
          id="resend-sms-transfer"
          data-cy="resendSmsTransferButton"
          onClick={handleResendTransferSms}
          disabled={resendSmsLoading || operationTime !== true}
        >
          <Translate contentKey="comexApp.quotation.resendSMS.resendSmsTransferLabel">Resend Transfer SMS</Translate>
        </Button>
      );
    }

    return null;
  }

  // re-initiate purchase
  function reInitiateButtons() {
    if (operationTime === true) {
      if (quotationEntity?.bursaAPIBidCertId === null &&
        (quotationEntity?.cancelOrder === null || quotationEntity?.cancelOrder === false) &&
        account?.authorities?.includes(AUTHORITIES.BANK_STAFF)) {

        const shouldHideButton =
          (isLocalCommodity &&
            quotationEntity?.bankManagerApproval !== null) ||
          quotationEntity?.bankManagerApproval === false ||
          serverStatus === false;

        return (<Button
            color="primary"
            id="save-entity"
            data-cy="entityCreateSaveButton"
            type="submit"
            onClick={handleRepurchase}
            disabled={isProcessingPurchase || updating}
            hidden={shouldHideButton}
          >
            {isProcessingPurchase && <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"/>}
            <Translate contentKey="comexApp.quotation.purchaseLabel" />
          </Button>
        )
      }
    }
  }

  const handleCloseManualOrderDialog = () => {
    setOpenManualOrderDialog(false);
  };

  useEffect(() => {
    setPurchaseFileName(quotationEntity?.bursaAPIBidCert?.uploadedCert === null ? '' : quotationEntity?.bursaAPIBidCert?.uploadedCert.split('/')[1]);
  }, [quotationEntity?.bursaAPIBidCert?.uploadedCert, quotationEntity])
  useEffect(() => {
    setTransferFileName(quotationEntity?.bursaAPIOtcCert?.uploadedCert === null ? '' : quotationEntity?.bursaAPIOtcCert?.uploadedCert.split('/')[1]);
  }, [quotationEntity?.bursaAPIOtcCert?.uploadedCert, quotationEntity])
  useEffect(() => {
    setSellFileName(quotationEntity?.bursaAPIStbCert?.uploadedCert === null ? '' : quotationEntity?.bursaAPIStbCert?.uploadedCert.split('/')[1]);
  }, [quotationEntity?.bursaAPIStbCert?.uploadedCert, quotationEntity])


  const formatDateTime = (currentDate: Date) => {
    const pad = (number: number) => String(number).padStart(2, '0');
    const padMilliseconds = (number: number) => String(number).padStart(3, '0');

    const hours = pad(currentDate.getHours());
    const minutes = pad(currentDate.getMinutes());
    const seconds = pad(currentDate.getSeconds());
    const milliseconds = padMilliseconds(currentDate.getMilliseconds());

    const day = pad(currentDate.getDate());
    const month = currentDate.toLocaleString('en-GB', { month: 'short' });
    const year = currentDate.getFullYear();

    return `${hours}:${minutes}:${seconds}.${milliseconds} ${day} ${month} ${year}`;
  };

  useEffect(() => {
    const ecertNo = quotationEntity?.bursaAPIBidCertId === null
      ? ecertBursaValue
      : quotationEntity?.bursaAPIBidCert?.ecertNo;

    // existing bursa bid cert data
    if(bidFileName !== null) {
      const fetchExistingBidCertData = async () => {
        if (ecertNo) {
          try {
            const result = await dispatch(getBursaBidCertByEcertNo(ecertNo));
            if (result?.payload?.['data']) {
              setExistingBursaBidData(result.payload['data']);
            } else {
              setExistingBursaBidData(null);
            }
          } catch (error) {
            setExistingBursaBidData(null);
          }
        }
      };

      fetchExistingBidCertData();
    }

    // existing bursa otc cert data
    if (otcFileName !== null) {
      const fetchExistingOtcCertData = async () => {
        if (ecertNo) {
          try {
            const result = await dispatch(getBursaOtcCertByEcertNo(ecertNo));
            if (result?.payload?.['data']) {
              setExistingBursaOtcData(result.payload['data']);
            } else {
              setExistingBursaOtcData(null);
            }
          } catch (error) {
            setExistingBursaOtcData(null);
          }
        }
      };

      fetchExistingOtcCertData();
    }

    // existing bursa stb cert data
    if (stbFileName !== null) {
      const fetchExistingStbCertData = async () => {
        if (ecertNo) {
          try {
            const result = await dispatch(getBursaStbCertByEcertNo(ecertNo));
            if (result?.payload?.['data']) {
              setExistingBursaStbData(result.payload['data']);
            } else {
              setExistingBursaStbData(null);
            }
          } catch (error) {
            setExistingBursaStbData(null);
          }
        }
      };

      fetchExistingStbCertData();
    }

  }, [quotationEntity, ecertBursaValue, bidFileName, otcFileName, stbFileName, dispatch]);

  const handleEcertInput = async (values) => {
    setLoadingSpinner(false);
    setIsSaveClick(true);
    setIsEditUploadCert(true);

    const obj = {
      endpointURL: "",
      ecertNo: quotationEntity?.bursaAPIBidCertId === null ? ecertBursaValue : quotationEntity?.bursaAPIBidCert?.ecertNo,
      memberShortName: "",
      successYN: "",
      msg: "",
      buyer: "",
      totalValue: amountData,
      currency: quotationEntity?.currencyIndex?.name || '',
      price: Number(""),
      priceMYR: Number(""),
      valueDate: "",
      pName: commodityNameData,
      pVolume: "",
      supplier: "",
      volume: amountData,
    }
    const createBy = {
      createdBy: account?.login,
    }

    const currentDate = new Date();

    if (bidFileName !== null) {
      if (quotationEntity?.bursaAPIBidCert?.uploadedCert !== null) {
        const deleteCert = async () => {
          try {
            const response = await axios.delete('/api/delete', {
              params: {
                key: "purchaseCert/" + quotationEntity?.bursaAPIBidCert?.uploadedCert
              }
            });
            console.warn('Object deleted successfully:', response.data);
          } catch (error) {
            console.error('Error deleting object:', error);
          }
        };
        try {
          await deleteCert();
        } catch (err) {
          console.error(err);
        }
      }

      // execute purchase in manual mode
      if (quotationEntity?.bursaAPIBidCertId === null && isEditUploadCert === false) {

        if (existingBursaBidData) {
          const bursaAPIBidEntity = await dispatch(updateBursaBidCert({
            ...existingBursaBidData,
            uploadedCert: "purchaseCert/" + bidFileName?.name,
          }));
          const updateEcertNoQuotation = await dispatch(updateEntity({
            ...quotationEntity,
            bursaAPIBidCert: bursaAPIBidEntity?.payload["data"],
            bursaAPIBidCertId: bursaAPIBidEntity?.payload["data"]?.id,
            isTransactionLocked: null,
            lockedByShserId: null,
          }));
        } else {
          const bursaAPIBidEntity = await dispatch(createBursaBidCert({
            ...obj,
            owner: "",
            bidNo: "",
            purchaseTimeDate: formatDateTime(currentDate),
            uploadedCert: "purchaseCert/" + bidFileName?.name,
          }));

          const updateEcertNoQuotation = await dispatch(updateEntity({
            ...quotationEntity,
            ...obj,
            bursaAPIBidCert: bursaAPIBidEntity?.payload["data"],
            bursaAPIBidCertId: bursaAPIBidEntity?.payload["data"]?.id,
            isTransactionLocked: null,
            lockedByShserId: null,
          }));
        }

      } else if (isEditUploadCert === false) {
        const bursaAPIBidEntity = await dispatch(updateBursaBidCert({
          ...existingBursaBidData,
          uploadedCert: "purchaseCert/" + bidFileName?.name,
        }));
        const updateEcertNoQuotation = await dispatch(updateEntity({
          ...quotationEntity,
          bursaAPIBidCert: bursaAPIBidEntity?.payload["data"],
          bursaAPIBidCertId: bursaAPIBidEntity?.payload["data"]?.id,
          isTransactionLocked: null,
          lockedByShserId: null,
        }));
      }

      // Upload BID Cert
      const handleUpload = async () => {
        const formData = new FormData();
        formData.append('file', bidFileName);
        try {
          const response = await axios.post(`/api/upload`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            params: {
              'uploadPath': 'purchaseCert',
            }
          });
          console.warn('File uploaded successfully:', response.data);
        } catch (error) {
          console.error('Error uploading file:', error);
        }
      };

      handleUpload();

      setIsBidId(true);
      setBidFileName(null);
    }
    if (otcFileName !== null) {
      if (quotationEntity?.bursaAPIOtcCert?.uploadedCert !== null) {
        const deleteCert = async () => {
          try {
            const response = await axios.delete('/api/delete', {
              params: {
                key: "transferCert/" + quotationEntity?.bursaAPIOtcCert?.uploadedCert
              }
            });
            console.warn('Object deleted successfully:', response.data);
          } catch (error) {
            console.error('Error deleting object:', error);
          }
        };
        try {
          await deleteCert();
        } catch (err) {
          console.error(err);
        }
      }

      // execute transfer in manual mode
      if (quotationEntity?.bursaAPIOtcCertId === null) {

        if(existingBursaOtcData){
          const bursaAPIOtcEntity = await dispatch(updateBursaOtcCert({
            ...existingBursaOtcData,
            uploadedCert: "transferCert/" + otcFileName?.name,
          }));
          const updateEcertNoQuotation = await dispatch(updateEntity({
            ...quotationEntity,
            bursaAPIOtcCert: bursaAPIOtcEntity?.payload["data"],
            bursaAPIOtcCertId: bursaAPIOtcEntity?.payload["data"]?.id,
            isTransactionLocked: null,
            lockedByShserId: null,
          }));
        } else {
          const bursaAPIOtcEntity = await dispatch(createBursaOtcCert({
            ...obj,
            seller: "",
            murabahValue: "",
            reportingTimeDate: formatDateTime(currentDate),
            uploadedCert: "transferCert/" + otcFileName?.name,
          }));

          const updateEcertNoQuotation = await dispatch(updateEntity({
            ...quotationEntity,
            ...obj,
            bursaAPIOtcCert: bursaAPIOtcEntity?.payload["data"],
            bursaAPIOtcCertId: bursaAPIOtcEntity?.payload["data"]?.id,
            isTransactionLocked: null,
            lockedByShserId: null,
          }));
        }
      } else {
        const bursaAPIOtcEntity = await dispatch(updateBursaOtcCert({
          ...existingBursaOtcData,
          uploadedCert: "transferCert/" + otcFileName?.name,
        }));
        const updateEcertNoQuotation = await dispatch(updateEntity({
          ...quotationEntity,
          bursaAPIOtcCert: bursaAPIOtcEntity?.payload["data"],
          bursaAPIOtcCertId: bursaAPIOtcEntity?.payload["data"]?.id,
          isTransactionLocked: null,
          lockedByShserId: null,
        }));
      }

      // Upload OTC Cert
      const handleUpload = async () => {
        const formData = new FormData();
        formData.append('file', otcFileName);
        try {
          const response = await axios.post(`/api/upload`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            params: {
              'uploadPath': 'transferCert',
            }
          });
          console.warn('File uploaded successfully:', response.data);
        } catch (error) {
          console.error('Error uploading file:', error);
        }
      };

      handleUpload();

      setIsOtcId(true);
      setOtcFileName(null);
    }
    if (stbFileName !== null) {
      if (quotationEntity?.bursaAPIStbCert?.uploadedCert !== null) {
        const deleteCert = async () => {
          try {
            const response = await axios.delete('/api/delete', {
              params: {
                key: "sellCert/" + quotationEntity?.bursaAPIStbCert?.uploadedCert
              }
            });
            console.warn('Object deleted successfully:', response.data);
          } catch (error) {
            console.error('Error deleting object:', error);
          }
        };
        try {
          await deleteCert();
        } catch (err) {
          console.error(err);
        }
      }


      // execute sell in manual mode
      if (quotationEntity?.bursaAPIStbCertId === null) {

        if(existingBursaStbData){
          const bursaAPIStbEntity = await dispatch(updateBursaStbCert({
            ...existingBursaStbData,
            uploadedCert: "sellCert/" + stbFileName?.name,
          }));
          const updateEcertNoQuotation = await dispatch(updateEntity({
            ...quotationEntity,
            bursaAPIStbCert: bursaAPIStbEntity?.payload["data"],
            bursaAPIStbCertId: bursaAPIStbEntity?.payload["data"]?.id,
            isTransactionLocked: null,
            lockedByShserId: null,
          }));
        } else {
          const bursaAPIStbEntity = await dispatch(createBursaStbCert({
            ...obj,
            seller: "",
            sellingTimeDate: formatDateTime(currentDate),
            uploadedCert: "sellCert/" + stbFileName?.name,
          }));

          const updateEcertNoQuotation = await dispatch(updateEntity({
            ...quotationEntity,
            ...obj,
            bursaAPIStbCert: bursaAPIStbEntity?.payload["data"],
            bursaAPIStbCertId: bursaAPIStbEntity?.payload["data"]?.id,
            isTransactionLocked: null,
            lockedByShserId: null,
          }));
        }
      } else {
        const bursaAPIStbEntity = await dispatch(updateBursaStbCert({
          ...existingBursaStbData,
          uploadedCert: "sellCert/" + stbFileName?.name,
        }));
        const updateEcertNoQuotation = await dispatch(updateEntity({
          ...quotationEntity,
          bursaAPIStbCert: bursaAPIStbEntity?.payload["data"],
          bursaAPIStbCertId: bursaAPIStbEntity?.payload["data"]?.id,
          isTransactionLocked: null,
          lockedByShserId: null,
        }));
      }

      // Upload STB Cert
      const handleUpload = async () => {
        const formData = new FormData();
        formData.append('file', stbFileName);
        try {
          const response = await axios.post(`/api/upload`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            params: {
              'uploadPath': 'sellCert',
            }
          });
          console.warn('File uploaded successfully:', response.data);
        } catch (error) {
          console.error('Error uploading file:', error);
        }
      };

      handleUpload();

      setIsStbId(true);
      setStbFileName(null);
    }
    setOpenManualOrderDialog(false);
    setLoading(false);
    setTimeout(() => {
      setLoading(true);
      window.location.reload();
    }, 2000);

  };

  const [purchaseCertError, setPurchaseCertError] = useState(false);
  useEffect(() => {
    if (purchaseFileName !== undefined && purchaseFileName !== '') {
      setPurchaseCertError(true);
    }
  })
  const isEditCert = (isBidId === true && quotationEntity?.bankCustomerApproval === false) || (isOtcId === true && quotationEntity?.stbOption === null) || isStbId === true;
  const handleUploadedPurchaseCert = async (e) => {
    const response = await dispatch(getEntityWithoutPending(props.match.params.id));
    const quotation = response.payload["data"];
    // console.warn(quotation?.bursaAPIBidCertId);
    if (quotation?.bursaAPIBidCertId !== null && quotation?.bursaAPIBidCertId !== undefined && isEditCert === false) {
      setOpenCertExistDialog(true);
      return;
    }

    setBidFileName(e.target.files[0]);
    setPurchaseFileName(e.target.files[0].name);
    if (e.target.files[0].name !== '' && isBidId === false) {
      setPurchaseCertError(true);
    }
  }

  const [transferCertError, setTransferCertError] = useState(false);
  useEffect(() => {
    if (transferFileName !== undefined && transferFileName !== '') {
      setTransferCertError(true);
    }
  })
  const handleUploadedTransferCert = async (e) => {
    const response = await dispatch(getEntityWithoutPending(props.match.params.id));
    const quotation = response.payload["data"];
    // console.warn(quotation?.bursaAPIOtcCertId);
    if (quotation?.bursaAPIOtcCertId !== null && quotation?.bursaAPIOtcCertId !== undefined && isEditCert === false) {
      setOpenCertExistDialog(true);
      return;
    }

    setOtcFileName(e.target.files[0]);
    setTransferFileName(e.target.files[0].name);
    if (e.target.files[0].name !== '' && isOtcId === false && quotationEntity?.status === "Transferred") {
      setTransferCertError(true);
    }
  }
  const [sellCertError, setSellCertError] = useState(false);
  useEffect(() => {
    if (sellFileName !== undefined && sellFileName !== '') {
      setSellCertError(true);
    }
  })
  const handleUploadedSellCert = async (e) => {
    const response = await dispatch(getEntityWithoutPending(props.match.params.id));
    const quotation = response.payload["data"];
    // console.warn(quotation?.bursaAPIStbCertId);
    if (quotation?.bursaAPIStbCertId !== null && quotation?.bursaAPIStbCertId !== undefined && isEditCert === false) {
      setOpenCertExistDialog(true);
      return;
    }

    setStbFileName(e.target.files[0]);
    setSellFileName(e.target.files[0].name);
    if (e.target.files[0].name !== '' && isStbId === false && quotationEntity?.status === "Sold") {
      setSellCertError(true);
    }
  }
  const [ecertNumberError, setEcertNumberError] = useState(false);
  useEffect(() => {
    if (quotationEntity?.bursaAPIBidCertId === null && ecertBursaValue === '') {
      setEcertNumberError(true);
    }
    else {
      setEcertNumberError(false);
    }
  })
  const handleOpenDialog = () => {
    setOpenCertExistDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenCertExistDialog(false);
    setTimeout(() => {
      setLoading(true);
      window.location.reload();
    }, 500);
  };

  const isUserAuthorizedToEdit = userRoleAccessList.length === 0 ||
    userRoleAccessList.some(role => role.bankId === quotationEntity?.bank.id);

  const isLockedByCurrentUser = (): boolean => {
    const isLockedByMe = quotationEntity?.isTransactionLocked === true && quotationEntity?.lockedByShserId === account?.id;
    const isUnlockedAndNoOwner = quotationEntity?.isTransactionLocked === null && quotationEntity?.lockedByShserId === null;

    return isLockedByMe || isUnlockedAndNoOwner;
  };

  const getShouldDisable = (): boolean => {
    const isDecisionMade = quotationEntity?.comexAdminDecision !== null;
    const isNotLocked = quotationEntity?.isTransactionLocked === false;
    return isDecisionMade || isNotLocked || !isLockedByCurrentUser();
  };

  function manualOrderRequestBtn() {


    if (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)) {
      return (
        <div>
          {!isLocalCommodity && (
          <Button
            color="primary"
            onClick={() => {
              setOpenManualOrderDialog(true);
            }}
            disabled={!isUserAuthorizedToEdit || (quotationEntity?.isTransactionLocked === false || !isLockedByCurrentUser())}
          >
            {isBidId === false && translate('comexApp.quotation.execute.executePurchase')}
            {(isOtcId === false && quotationEntity?.status === 'Transferred') && translate('comexApp.quotation.execute.executeTransfer')}
            {(isStbId === false && quotationEntity?.status === 'Sold') && translate('comexApp.quotation.execute.executeSell')}
            {((isBidId === true && quotationEntity?.bankCustomerApproval === false) ||
              (isOtcId === true && quotationEntity?.stbOption === null) ||
              isStbId === true) && translate('comexApp.quotation.execute.editUploadedCert')}
          </Button>
          )}
          <CertExistsConfirmationDialog
            open={openCertExistDialog}
            onClose={handleCloseDialog}
          />
          <ManualOrderDialog
            openManualOrderDialog={openManualOrderDialog}
            maxWidth={maxWidth}
            isBidId={isBidId}
            isOtcId={isOtcId}
            isStbId={isStbId}
            quotationEntity={quotationEntity}
            ecertBursaValue={ecertBursaValue}
            setEcertBursaValue={setEcertBursaValue}
            ecertNumberError={ecertNumberError}
            purchaseCertError={purchaseCertError}
            transferCertError={transferCertError}
            sellCertError={sellCertError}
            purchaseFileName={purchaseFileName}
            transferFileName={transferFileName}
            sellFileName={sellFileName}
            fileUpload={fileUpload}
            handleUploadedPurchaseCert={handleUploadedPurchaseCert}
            handleUploadedTransferCert={handleUploadedTransferCert}
            handleUploadedSellCert={handleUploadedSellCert}
            handleCloseManualOrderDialog={handleCloseManualOrderDialog}
            handleEcertInput={handleEcertInput}
            isSaveClick={isSaveClick}
            labelStyle={labelStyle}
            inputStyle={inputStyle}
          />
          <div className="overlay" hidden={loadingSpinner}>
            <img
              src="../../content/images/loading.gif"
              style={{ alignContent: 'center', position: 'fixed', left: '46%', top: '40%', zIndex: '1000' }}
              hidden={loadingSpinner}
            />
          </div>
        </div>
      )
    }
  }


  const canShowInvoiceSection = (): boolean => {
    const hasAccess = !account.authorities.includes(AUTHORITIES.CUSTOMER) &&
      (account.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
        account.authorities.includes(AUTHORITIES.ALSHMOKH_USER) ||
        quotationEntity?.bank?.invoiceEnabled);

    return (
      hasAccess &&
      isLocalCommodity &&
      quotationEntity?.localCommodityStbCertId !== null &&
      !!quotationEntity?.id
    );
  };

  const canShowLocalFormSection = (): boolean => {
    const hasAccess = !account.authorities.includes(AUTHORITIES.CUSTOMER) &&
      (account.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
        account.authorities.includes(AUTHORITIES.ALSHMOKH_USER) ||
        quotationEntity?.bank?.localFormEnabled);

    return (
      hasAccess &&
      isLocalCommodity &&
      quotationEntity?.status === "Sold"
    );
  };

  const canShowPoaFormSection = (): boolean => {
    const hasAccess = !account.authorities.includes(AUTHORITIES.CUSTOMER) &&
      (account.authorities.includes(AUTHORITIES.ALSHMOKH_ADMIN) ||
        account.authorities.includes(AUTHORITIES.ALSHMOKH_USER) ||
        quotationEntity?.bank?.poaFormEnabled);

    return (
      hasAccess &&
      isLocalCommodity &&
      quotationEntity?.status === "Sold"
    );
  };

  const canShowAmountTransferredSection = (): boolean => {
    const allowedAuthorities = [
      AUTHORITIES.ADMIN,
      AUTHORITIES.ALSHMOKH_ADMIN,
      AUTHORITIES.ALSHMOKH_USER
    ];

    const hasAccess = account.authorities.some(auth =>
      allowedAuthorities.includes(auth)
    );

    return (
      hasAccess &&
      isLocalCommodity &&
      quotationEntity?.status === "Sold"
    );
  };

  const handleAmountTransferredChange = (checked: boolean) => {
    const updatedQuotationEntity = {
      ...quotationEntity,
      amountTransferred: checked
    }
    dispatch(updateEntity(updatedQuotationEntity));
  };

  useEffect(() => {
    const ecertNoToStore = isLocalCommodity
      ? quotationEntity?.localCommodityBidCert?.ecertNo
      : quotationEntity?.bursaAPIBidCert?.ecertNo;

    localStorage.setItem("ecertNo", ecertNoToStore);
    if (quotationEntity && quotationEntity?.status === "Bought" && quotationEntity?.smsLanguage === "ENG")
      setIsTransferRequested(true);

    // Reset processing flags when the backend confirms the cert was saved.
    // Covers both international (bursaAPI*CertId) and local commodity certs.
    if (quotationEntity?.bursaAPIOtcCertId != null || quotationEntity?.localCommodityOtcCertId != null) {
      setIsProcessingTransfer(false);
      setIsConfirmingTransfer(false);
    }
    if (quotationEntity?.bursaAPIBidCertId != null || quotationEntity?.localCommodityBidCertId != null) {
      setIsProcessingPurchase(false);
    }
    if (quotationEntity?.bursaAPIStbCertId != null || quotationEntity?.localCommodityStbCertId != null) {
      setIsProcessingSell(false);
    }

  }, [quotationEntity, purchaseCancellation]);


  const handleClose = () => {
    setIsDialogOpen(false);
    setRequestCancellationReason("");
  };


  const handleKeepClose = () => {
    setIsKeepDialogOpen(false);
    dispatch(updateEntity({
      ...quotationEntity,
      isTransactionLocked: null,
      lockedByShserId: null,
    }));
  };

  useEffect(() => {
    if (updateSuccess) {
      setIsDialogOpen(false);
    }
  }, [updateSuccess]);

  const handleCustomerApproval = e => {
    setCheckedCustomerApproval(e.target.checked);
  };

  const goBackToHome = () => {
    setLoading(false);
    setTimeout(() => {

      props.history.push('/home');
    }, 3000);
  }

  const goBackToHomeTransfer = () => {
    setLoading(false);
    setTimeout(() => {
      props.history.push('/home');
      // window.location.href = '/home';
    }, 3000);
  }

  const reloadPage = () => {
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  }

  const goBackToCancelOrder = () => {
    props.history.push('/cancelOrder');
  }

  useEffect(() => {
    const handleStorageChange = () => {
      const showError = localStorage.getItem('showErrorDialog');
      if (isSold) {
        // Stay on the Boubyan quotation page after a successful sell instead of redirecting to the dashboard
        if (quotationSuccess && showError === 'true') {
          reloadPage();
        }
      } else if (isTransferRequested) {
        if (quotationSuccess && showError === 'false') {
          goBackToHomeTransfer();
        } else if (quotationSuccess && showError === 'true') {
          reloadPage();
        }
      }
    };

    window.addEventListener('localStorageUpdate', handleStorageChange);
    return () => {
      window.removeEventListener('localStorageUpdate', handleStorageChange);
    };
  }, [updateSuccess, quotationSuccess, isTransferRequested, isSold]);

  useEffect(() => {
    // redirect url for Keep/Sell
    if (keepCus) {
      if (quotationSuccess) {

        goBackToHome();
      }
    }
    // redirect url for cancellation
    else if (cancel) {
      if (updateSuccess && quotationSuccess) {
        goBackToCancelOrder();
      }
    } else if (cancelDeny) {
      if (updateSuccess && quotationSuccess) {
        goBackToHome();
      }
    } else if (requestCancel) {
      if (updateSuccess && quotationSuccess && notificationSuccess) {
        goBackToCancelOrder();
      }
    } else if (approveByBranch) {
      if (updateSuccess) {
        goBackToCancelOrder();
      }
    }
    else if (isRepurchase) {
      if (quotationSuccess)
        goBackToHome();
    }
  }, [updateSuccess, quotationSuccess]);

  function branchManagerCancellationApprovalButtons() {

    return (<>

        <Button
          variant="contained"
          color="danger"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          type="submit"
          onClick={handleDenyCancellation}
          disabled={(purchaseCancellation.result === 'CANCELLED' || cancelDeny === true) || (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && (quotationEntity?.isTransactionLocked === false || !isLockedByCurrentUser()))}
        >
          <Translate contentKey="comexApp.quotation.DenyBtnLabel">Deny</Translate>
        </Button>
        &nbsp;
        <Button
          variant="contained"
          color="primary"
          id="save-entity"
          data-cy="entityCreateSaveButton"
          type="submit"
          onClick={handleApproveCancellation}
          disabled={(purchaseCancellation.result === 'CANCELLED' || cancel === true || approveByBranch === true) || (account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER) && (quotationEntity?.isTransactionLocked === false || !isLockedByCurrentUser()))}
        >
          <Translate contentKey="comexApp.quotation.ApproveBtnLabel">Approve</Translate>
        </Button>
      </>
    );

  }

  function getDateOnly(dateValue) {
    return new Date(dateValue.getFullYear(), dateValue.getMonth(), dateValue.getDate());
  }

  useEffect(() => {
    if (account?.login !== undefined && !isReady) {
      if (quotationEntity?.branch?.id !== undefined) {
        setIsReady(true);
        dispatch(getBranch(quotationEntity?.branch.id));
      }
    }
  }, [account, quotationEntity]);
  useEffect(() => {
    if (specBranch?.id !== undefined &&
      account?.authorities !== undefined &&
      quotationEntity?.id !== undefined &&
      !isDone) {
      setIsDone(true);
    }
  }, [specBranch, account, quotationEntity, isDone])

  let responsiveFont = createTheme();
  responsiveFont = responsiveFontSizes(responsiveFont);
  const handleToClose = () => {
    setOpenSMSModal(false);
    setIsConfirmingTransfer(false);
    setIsProcessingTransfer(false);
    transferInProgressRef.current = false;
  };
  const handleSmsLanguage = (event) => {
    setSMSLanguage(event.target.value);
  }
  useEffect(() => {
    setSMSLanguage(Storage.session.get('locale') === 'en' ? 'EN' : 'AR');
  }, [sessionStorage.getItem('locale')])

  // For Add Buyer
  const accountsUser = useAppSelector(state => state.userManagement.accountsUser);
  useEffect(() => {
    dispatch(getUsersAsAlmoskhAdminAndStaff({}));
  },[dispatch])

  const [openAddBuyerModal, setOpenAddBuyerModal] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const handleAddBuyerModal = (existingBuyer = null) => {
    if (openAddBuyerModal) {
      setOpenAddBuyerModal(false);
      setSelectedBuyer(null);
    } else {
      setSelectedBuyer(existingBuyer);
      setOpenAddBuyerModal(true);
    }
  };


  const testUser: IUser[] = [];
  accountsUser?.forEach(s => {
    if(s.authorities.includes(AUTHORITIES.BUYER_OF_COMMODITIES)){
      testUser.push(s);
    }
  });

  const getNameForBuyer = (option: IUser): string => {
    return `${option.firstName} ${option.lastName || ''}`;
  };

  const handleOnChangeAddBuyer = (event, chooseBuyer) => {
    setSelectedBuyer(chooseBuyer);
  };

  const handleAddBuyerConfirm = () => {
    const updatedQuotationEntity = {
      ...quotationEntity,
      commodityBuyer: selectedBuyer,
      commodityBuyerId: selectedBuyer.id
    }
    dispatch(updateEntity(updatedQuotationEntity));
    setOpenAddBuyerModal(false);
  }

  const getPoId = () => {
    return isLocalCommodity
      ? (quotationEntity?.localCommodityBidCertId === null ? '-' : quotationEntity?.localCommodityBidCert?.ecertNo)
      : (quotationEntity?.bursaAPIBidCertId === null ? '-' : quotationEntity?.bursaAPIBidCert?.ecertNo);
  };

  const poId = getPoId();

  if (isDone) {
    if ((account?.authorities?.includes(AUTHORITIES.BRANCH_MANAGER))
      || (account?.authorities?.includes(AUTHORITIES.BANK_STAFF) && quotationEntity?.createdBy === account?.login)
      || (account?.authorities?.includes(AUTHORITIES.AREA_MANAGER) && specBranch?.areaManagerId === account?.id)
      || (account?.authorities?.includes(AUTHORITIES.BANK_MANAGER) && specBranch?.bank?.userId === account?.id)
      || (account?.authorities?.includes(AUTHORITIES.CUSTOMER) && quotationEntity?.customer.ic.toLowerCase() === account?.login)
      || (account?.authorities?.includes(AUTHORITIES.AUDITOR) && specBranch?.bank?.id?.toString() === account?.bankId)
      || account?.authorities?.includes(AUTHORITIES.ALSHMOKH_ADMIN) || account?.authorities?.includes(AUTHORITIES.ADMIN)
      || account?.authorities?.includes(AUTHORITIES.ALSHMOKH_USER)) {
      return (
        <div className="boubyan-quotation-bought">
          <div className="overlay" hidden={loading}>
            <img src="../../content/images/loading.gif" style={{
              alignContent: "center",
              position: "fixed",
              left: "46%",
              top: "40%",
              zIndex: "1000"
            }} hidden={loading}/>
          </div>

          <SlotProcessingDialog
            open={slotAlreadyProcessing !== null}
            slotType={slotAlreadyProcessing}
            onClose={() => setSlotAlreadyProcessing(null)}
          />

          <SmsDialog key={"ar"} open={openSMSModal} onClose={handleToClose}
                     repurchase={isRepurchase}
                     value={SMSLanguage} onChange={handleSmsLanguage} onClick={saveEntity}
                     disabled={isConfirmingTransfer}/>

          <RequestCancellationDialog open={isDialogOpen} onClose={handleClose} maxWidth={maxWidth}
                                     poId={poId} account={account} error={validateCancellation}
                                     helperText={errorText}
                                     purchaseCancellation={purchaseCancellation}
                                     requestCancellationReason={requestCancellationReason}
                                     onChange={(e) => setRequestCancellationReason(e.target.value)}
                                     manager={manager} alshmokhAdmin={alshmokhAdmin}
                                     quotationEntity={quotationEntity}
                                     element={branchManagerCancellationApprovalButtons()}
                                     onClick={handleRequestCancellation} disabled={requestCancel}/>

          <ApprovalDialog open={isKeepDialogOpen} onClose={handleKeepClose} poId={poId}
                          onClick={handleSell} quotationEntity={quotationEntity}
                          onClick1={handleKeep}/>
          <Row className="justify-content-center">
            <Col md="8" lg="6" style={{marginTop: '26px'}}>
              <Row style={{alignItems: 'center'}}>
                <Col md="8" style={{display: 'inline-flex', justifyContent: 'flex-start'}}>
                  <QuotationTitle
                    purchaseCancellation={purchaseCancellation}
                    quotationEntity={quotationEntity}
                    responsiveFont={responsiveFont}
                  />
                </Col>

                <Col md="4" style={{display: 'inline-flex', justifyContent: 'flex-end'}}>
                  <CancelOrderButton
                    purchaseCancellation={purchaseCancellation}
                    quotationEntity={quotationEntity}
                    account={account}
                    poCreatedDateData={poCreatedDateData}
                    getDateOnly={getDateOnly}
                    handleRequestCancellationClick={handleRequestCancellationClick}
                    AUTHORITIES={AUTHORITIES}
                    bank={quotationEntity?.bank}
                  />
                </Col>
              </Row>
            </Col>

            <Row className="justify-content-center" style={{marginTop: '12px'}}>
              <Col md="8" lg="6" className="round-border mt-1"
                   style={{padding: '28px 42px 28px 42px'}}>
                <ThemeProvider theme={responsiveFont}>
                  <Typography variant="h6" component="div">
                    <strong>{translate('comexApp.quotation.orderInfoLabel')}</strong>
                  </Typography>
                </ThemeProvider>
                &nbsp;

                <QuotationBoughtForm
                  quotationEntity={quotationEntity}
                  poNumberData={poNumberData}
                  poCreatedDateData={poCreatedDateData}
                  currencyNameData={quotationEntity?.currencyIndex?.name || ''}
                  amountData={amountData}
                  commodityNameData={commodityNameData}
                  descriptionData={descriptionData}
                  itemDescriptionInArabic={itemDescriptionInArabic}
                  commodityUnitPriceData={commodityUnitPriceData}
                  commodityQuantityData={commodityQuantityData}
                  commodityUnitData={commodityUnitData}
                  transactionFeeData={transactionFeeData}
                  feeInQuotationCurrencyData={feeInQuotationCurrencyData}
                  totalAmountData={totalAmountData}
                  customerICData={customerICData}
                  customerNameData={customerNameData}
                  customerNameArData={customerNameArData}
                  customerTelData={customerTelData}
                  customerEmailData={customerEmailData}
                  branchCustomerApproval={branchCustomerApproval}
                  handleToSubmit={handleToSubmit}
                  isLocalCommodity={isLocalCommodity}
                  operationTime={operationTime}
                  comexSettingsEntity={comexSettingsEntity}
                  shouldRenderButton={shouldRenderButton}
                  handleAmendClick={handleAmendClick}
                  transferAndKeepSellButtons={transferAndKeepSellButtons}
                  reInitiateButtons={reInitiateButtons}
                  manualOrderRequestBtn={manualOrderRequestBtn}
                  purchaseCancellation={purchaseCancellation}
                  renderIban={renderIban}
                  isDefaultCurrency={isDefaultCurrency}
                  account={account}
                  checkedCustomerApproval={checkedCustomerApproval}
                  handleCustomerApproval={handleCustomerApproval}
                  resendSmsButtons={resendSmsButtons}
                  localStart={localStart}
                  localEnd={localEnd}
                  serverStatus={serverStatus}
                />
              </Col>
            </Row>
            &nbsp;

            {quotationEntity?.bank?.transaction_forms !== false && (
              <div>
                <TransactionForms
                  createdByBankStaff={quotationEntity?.branch}
                  responsiveFont={responsiveFont}
                  isLocalCommodity={isLocalCommodity}
                  quotationEntity={quotationEntity}
                  getPurchaseColor={getPurchaseColor}
                  getTransferColor={getTransferColor}
                  getSellColor={getSellColor}
                />
              </div>
            )}

            {isLocalCommodity &&
              (quotationEntity?.bank?.requireDocumentUpload ? quotationEntity?.localCommodityBidCertId !== null : quotationEntity?.status === "Sold") &&
              !account.authorities.includes(AUTHORITIES.CUSTOMER) && (
              <div>
                <DocUploadForm
                  transactionRefNo={quotationEntity?.transactionRefNo}
                  responsiveFont={true}
                  quotationEntity={quotationEntity}
                  updateDocCallback={() => updateDocCallback()}
                  account={account}
                />
              </div>
            )}

            <div>
              {(canShowInvoiceSection() || canShowLocalFormSection() || canShowPoaFormSection()) &&
                <FormsTableSection
                  responsiveFont={responsiveFont}
                  quotationEntity={quotationEntity}
                  getSellColor={getSellColor}
                  canShowInvoiceSection={canShowInvoiceSection()}
                  canShowLocalFormSection={canShowLocalFormSection()}
                  canShowPoaFormSection={canShowPoaFormSection()}
                />
              }
            </div>

            <div>
              {canShowAmountTransferredSection() &&
                <Row className="justify-content-center" style={{marginTop: '12px'}}>
                  <AmountTransferredSection
                    responsiveFont={responsiveFont}
                    quotationEntity={quotationEntity}
                    onAmountTransferredChange={handleAmountTransferredChange}
                  />
                </Row>}
            </div>

            { /* For ADD IBAN NUMBER */}
            <AddIbanDialog
              openIBANModal={openIBANModal}
              handleIBANModal={handleIBANModal}
              selectedIBANOption={selectedIBANOption}
              handleIBANRadioChange={handleIBANRadioChange}
              ibanValue={ibanValue}
              isValidIBANNumber={isValidIBANNumber}
              getIBANHelperText={getIBANHelperText}
              handleIBANInputChange={handleIBANInputChange}
              bankNameValue={quotationEntity?.bank?.name || ''}
              branchNameValue={quotationEntity?.branch?.name || ''}
              handleIBANConfirm={handleIBANConfirm}
              isSubmittingIban={isSubmittingIban}
            />

            { /* For Add Buyer */}
            <AddBuyerDialog
              openAddBuyerModal={openAddBuyerModal}
              handleAddBuyerModal={() => handleAddBuyerModal(null)}
              testUser={testUser}
              getNameForBuyer={getNameForBuyer}
              handleOnChangeAddBuyer={handleOnChangeAddBuyer}
              handleAddBuyerConfirm={handleAddBuyerConfirm}
              selectedBuyer={selectedBuyer}
            />

            { /* For Resend SMS */}
            <ResendSmsDialog
              openResendSmsDialog={openResendSmsDialog}
              handleResendSmsClose={handleResendSmsClose}
              resendSmsType={resendSmsType}
              resendSmsStatus={localSmsStatus || (resendSmsError ? 'error' : '')}
              resendSmsError={localSmsError || resendSmsError}
              quotationEntity={quotationEntity}
            />

          </Row>
          <ErrorDialog history={props.history} isLocalCommodity={isLocalCommodity}/>
        </div>
      );
    } else {
      return (
        <div className="insufficient-authority">
          <div className="alert alert-danger">
            <Translate contentKey="error.http.403">You are not authorized to access this page.</Translate>
          </div>
        </div>
      );
    }
  } else {
    return (
      <>
        <h5 style={{textAlign: 'center'}}><Translate contentKey={"global.loading"}/></h5>
      </>
    );
  }

};

export default QuotationBought;
